import React, { useRef, useEffect, useState } from "react";
import Button from "../../component/button/Button";
import alluraFont from "../../config/onboarding/allura-font";
import "../../styles/pages/welcome.scss";
import Label from "../../component/label/Label";
import {
  checkIsSignedorNot,
  createCandidateDataDocuments,
  getCandidateData,
  loderControl,
  loderOffControl,
} from "../../redux/slices/newRoleSlices";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, useFormikContext, Field, FieldArray } from "formik";
import * as htmlToImage from "html-to-image";
import FormikControl from "../../formikControl/FormikControl";
import Model from "../../component/modal/Modal";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useNavigate } from "react-router-dom";
import { apiPost } from "../../service/apiService";
import { endPoint } from "../../config/endPoint";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Loader from "../../component/loader/Loader";
import Iframe from "../../component/formikComponent/Iframe";
import jsPDF from "jspdf";
import autoTable, { RowInput } from "jspdf-autotable";

type SignExportTableUrlData = {
  type: "file-url" | "make-bold" | "signature";
  items?: { name: string; url: string }[];
  item?: string;
};
import { toast } from "react-toastify";
import {
  domainWithHttp,
  oldFile,
  stepes,
  updateOldFile,
} from "../../config/onboarding/onBoarding";
import { ExportTableUrlData } from "../../types/types";
import Image from "../../component/image/Image";
import Bin from "../../assets/images/bin.png";
import DocIcon from "../../assets/images/doc-icon.svg";
import "../../styles/timeline.scss";
import Slider from "react-slick";
import { number } from "yup";
import { get, param } from "jquery";
import { isEditFormDocSigned } from "./formUtils";
interface CandidateData {
  activeStyle: boolean;
  candidateId: string;
  clientId: string;
  fields: any[];
  formId: string;
  label: string;
  active?: boolean;
  indata?: any;
  data?: any[];
  currentPage?: boolean;
  currentPageStyle?: string;
  completedPage?: string;
}

let formstatus = "draft";
let checkTimeline = "";
export let valudatesetformstatus = "";

export const updateValudatesetFormstatus = (params: any) => {
  valudatesetformstatus = params;
};

let formstatusTwo = false;
export let checkValidationElement: any = [];

export const setchioldValidation = (params: any) => {
  checkValidationElement = params;
};

export let childDisplay: any = {};
let apiIndex = 0;
let fileValue = 0;
let changeParams: any = null;

const OnBoarding = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const candidateData = useSelector((state: any) => {
    return state?.newRole?.candidateData;
  });


  const teamConfig = useSelector((state: any) => {
    return state?.newRole?.teamConfig;
  });
  const loader = useSelector((state: any) => {
    return state?.newRole?.loading;
  });
  const getAPIError = useSelector((state: any) => {
    return state?.newRole?.error;
  });
  const candidateDataDocuments = useSelector((state: any) => {
    return state?.newRole?.createCandidateDataDocuments;
  });
  const [updateFormData, setUpdateFormData] = useState<CandidateData[]>([]);

  const formRef = useRef<any>([]);
  const [screenShort, setScreenShort] = useState({
    active: true,
  });

  const [pageResload, setPageReload] = useState(false);
  const [signedUrl, setSignedUrl] = useState("");
  const [signingUrl, setSigningUrl] = useState("");
  const [isSigned, setIsSigned] = useState(false);

  const [superSignedUrl, setSuperSignedUrl] = useState("");
  const [superSigningUrl, setSuperSigningUrl] = useState("");
  const [isSuperSigned, setIsSuperSigned] = useState(false);

  const [isTFNFormChanges, setIsTFNFormChanges] = useState(false);
  const [isSuperFormChanges, setIsSuperFormChanges] = useState(false);
  const [tfnFormIndex, setTfnFormIndex] = useState<number | null>(null);
  const [superFormIndex, setSuperFormIndex] = useState<number | null>(null);
  const [isLastPage, setIsLastPage] = useState(false);
  const [candidateId, setCandidateId] = useState("");
  //this handles sign for one field in the form
  // const [candidateSignModel, setCandidateSignModel] = useState<string>("");
  // this handles sign for multiple fields in the form
  const [candidateSignModel, setCandidateSignModel] = useState<{ [key: string]: string }>({});


  const [tfnFieldValue, setTfnFieldValue] = useState<any>("");
  const [doTfnFormValidation, setDoTfnFormValidation] = useState("");


  const [countControl, setCountControl] = useState({
    show: false,
    uploadList: 0,
    fileCount: 0,
    fileUrls: [],
    saveModel: false,
    saveDraftTest: false,
    fileUplaod: false,
    parentage: 0,
    pageReload: false,
    timelineUpdate: false
  });

  const [iframeData, setIframeData] = useState({
    data: [],
    index: null,
    apiCall: false,
    errorSign: false,
    sigcontrol: false,
  });

  const ref = useRef(null);

  const [saveModel, setSaveModel] = useState(false);
  const [isTfnForm, setIsTfnForm] = useState(0);
  const [isSuperForm, setIsSuperForm] = useState(0);
  const [totalFile, setTotalFile] = useState<any>([]);
  const [movinIndex, setMovingIndex] = useState({
    fieldIndex: 0,
    fileIndex: 0,
    indexClose: false,
    totalFileUploadIndex: 0,
  });
  const [fileUploadValue, setFileUploadValue] = useState(0);
  const [uploadFileUrl, setUplaodFileUrl] = useState<any>([]);
  const [saveAndExitModel, setSveAndExitModel] = useState(false);
  const [saveToExitModel, setSaveToExitModel] = useState(false);
  const [dataIsUpdated, setDataIsUpdated] = useState(false);
  const [clearChilInput, setClearChilInput] = useState(false);
  const [slickStyleUpdate, setSlickStyleUpdate] = useState({
    index: 5,
    currentPage: 0,
    nextIndex: 4
  });
  const [getScreenWidth, setGetScreenWidth] = useState({
    width: 0,
    height: 0,
    showCount: 5
  });
  const [getOrientationChange, setOrientationChange] = useState({
    timeStamp: "0"
  });
  const sliderRef = useRef<any>(null);
  const [getFilesForDeletion, setFilesForDeletion] = useState<any>([]);

  const [expiredLinkMessage, setExpiredLinkMessage] = useState("");
  const expiredToastShownRef = useRef(false);

  const extractExpiredLinkMessage = (response: any): string => {
    const statusCode = Number(
      response?.status ??
      response?.data?.statusCode ??
      response?.data?.data?.statusCode
    );
    const message =
      response?.data?.message ||
      response?.message ||
      response?.data?.data?.message ||
      "";

    if (statusCode === 403 && typeof message === "string" && message.trim()) {
      return message.trim();
    }

    if (typeof message === "string" && /link has been expired/i.test(message)) {
      return message.trim();
    }

    return "";
  };

  const handleExpiredLink = (response: any): boolean => {
    const message = extractExpiredLinkMessage(response);
    if (!message) {
      return false;
    }

    setExpiredLinkMessage((prev) => prev || message);
    dispatch(loderOffControl());
    if (!expiredToastShownRef.current) {
      toast(message, {
        type: "error",
      });
      expiredToastShownRef.current = true;
    }

    return true;
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 75,
    arrow: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          initialSlide: 2
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ],
    afterChange: (current: any) => {
      setSlickStyleUpdate((prs) => {
        return {
          ...prs,
          currentPage: current,
          // index: current === 0 ? 5 : ((current + 1) * 5),
          // frontIndex: current === 0 ? 5 : (((current + 1) * 5) - 5)
        };
      });

    },
    beforeChange: (currentSlide: number, nextSlide: number) => {
      setSlickStyleUpdate((prs) => {
        return {
          ...prs,
          // index: current === 0 ? 5 : ((current + 1) * 5),
          nextIndex: getScreenWidth.showCount === 5 ? nextSlide + 4 : nextSlide + 2
        };
      });
    }

  };

  // useEffect(() => {
  //     dispatch<any>(clientSettingsConfig());
  // }, []);

  useEffect(() => {
    if (screen.width < 575) {
      setGetScreenWidth((prs: any) => {
        return {
          ...prs,
          width: screen.width,
          showCount: 3
        };
      });
    }
    document.body.classList.add("cust-template-new-page-id-1");
  }, []);

  // useEffect(() => {
  //   if (signedUrl) {
  //     etGetScreenWidth((prs: any) => {
  //       return {
  //         ...prs,
  //         width: screen.width,
  //         showCount: 3
  //       };
  //     });
  //   }
  // }, [signedUrl]);

  
  let orientationChanged:any = 0;
  const handleOrientationChange = (e:any) => {
    setOrientationChange((orientationState: any) => {
      return {
        ...orientationState,
        timeStamp: e.timeStamp
      };
    });   
  };
  useEffect(() => {
    window.addEventListener("orientationchange", handleOrientationChange);
  }, []);

  useEffect(() => {
    if (!countControl.saveModel && !saveModel && pageResload) {
      window.location.reload();
    }
  }, [countControl]);

  useEffect(() => {
    if (candidateData?.statusCode === 200) {
      if(candidateData?.data[0]?.isTFNForm === 1){
        document.body.classList.add("tfnForm"); 
        setIsTfnForm(1);
      } 

      if(candidateData?.data[0]?.isSuperForm === 1){
        document.body.classList.add("theme-form-id1"); 
        setIsSuperForm(1);
      } else {
        document.body.classList.remove("theme-form-id1"); 
      }
    }
}, []);

const isEditFormDocSigned = async (candidateId: any, isEditTFNForm: boolean = false, isEditSuperForm: boolean = false) => {
  const obj: any = {};
  const activeForm: any[] = updateFormData.filter(
    (ress) => (ress.active === true)
  );
  const activeFormIndex = updateFormData.findIndex((ress) => ress.active);
  let activePageNumber = (activeFormIndex ?? 0) + 1;
  const formName = activeForm[0]?.label || "";
  obj["CandidateId"] = candidateId;
  obj["formName"] = formName;
  obj["activePageNumber"] = activePageNumber;
  obj["isSuperForm"] = isEditSuperForm ? true : false;
  obj["isTfnForm"] = isEditTFNForm ? true : false;
  let specialFormIndex = null;

  if(isEditSuperForm){
    specialFormIndex = superFormIndex;
  }else if(isEditTFNForm){
    specialFormIndex = tfnFormIndex;
  }

  const candidateDataRess = await dispatch<any>(checkIsSignedorNot(obj));

  let docsPayload = candidateDataRess?.payload?.data?.message;
  if (docsPayload === "Form Signed") {
    if(isEditTFNForm){
      setIsSigned(true);
      setSigningUrl("");
    }else if(isEditSuperForm){
      setIsSuperSigned(true);
      setSuperSigningUrl("");
    }
    let formData = updateFormData;
    let currentFormIndex = specialFormIndex;
    let previousFormIndex = specialFormIndex !== null ? specialFormIndex - 1 : 0;
    let nextFormIndex = specialFormIndex !== null ? specialFormIndex + 1 : 0;

    if (specialFormIndex !== null && isEditTFNForm) {
      if (currentFormIndex !== null && formData[currentFormIndex]) {
        formData[currentFormIndex].active = true;
      }
    } else if (superFormIndex !== null && isEditSuperForm) {
      if (currentFormIndex !== null && formData[currentFormIndex]) {
        formData[currentFormIndex].active = true;
      }
    } else {
      if (nextFormIndex !== null && formData[nextFormIndex]) {
        formData[nextFormIndex].active = true;
      }

      if (currentFormIndex !== null && formData[currentFormIndex]) {
        formData[currentFormIndex].active = false;
        document.body.classList.remove("tfnForm");
      }
    }

    if (!isEditTFNForm && !isEditSuperForm) {
      setUpdateFormData(formData);
    }
    

    if (specialFormIndex !== null && formData.length === (specialFormIndex + 1) && !isEditTFNForm && !isEditSuperForm) {
      setIsLastPage(true);
      setFileUploadValue(100);
    }

    setIsTFNFormChanges(false); // When submitting it from iframe page, we need to pass isTFNFormChanged as 0 to create pdf file in API side.
    setIsSuperFormChanges(false); // When submitting it from iframe page, we need to pass isSuperForm
  } else {
    if (!isEditTFNForm && !isEditSuperForm) {
      toast("Please sign the document.", {
        type: "error",
        autoClose: 60000,
      });
    }
    setIsSigned(false);
    setSigningUrl("");
    setSignedUrl("");

    setIsSuperSigned(false);
    setSuperSigningUrl("");
    setSuperSignedUrl("");
  }
};

// const handleCheckSignature = async (candidateId: any, isEditTFNForm: boolean = false, isEditSuperForm: boolean = false) => {
//   isEditFormDocSigned(
//     candidateId,
//     isEditTFNForm,
//     isEditSuperForm,
//     updateFormData,
//     dispatch,
//     setIsSigned,
//     setSigningUrl,
//     setSignedUrl,
//     setUpdateFormData,
//     setIsLastPage,
//     setFileUploadValue,
//     setIsTFNFormChanges,
//     setIsSuperFormChanges,
//     setIsSuperSigned,
//     setSuperSigningUrl,
//     setSuperSignedUrl
//   );
// };

const isDocSigned: (params: any, formName: string, activePageNumber: number) => Promise<void> = async (params: any, formName: string, activePageNumber: number) => {
  const obj: any = {};
  obj["CandidateId"] = params;
  obj["formName"] = formName;
  obj["activePageNumber"] = activePageNumber;
  let isSuperFormData = updateFormData.filter((ress: any) => ress?.isSuperForm === 1 && ress?.active === true);
  let isTFNFormData = updateFormData.filter((ress: any) => ress?.isTFNForm === 1 && ress?.active === true);
  if(isSuperFormData?.length > 0){
    obj["isSuperForm"] = true;
  }else {
    obj["isSuperForm"] = false;
  }
  
  if(isTFNFormData?.length > 0){
    obj["isTfnForm"] = true;
  }else{
    obj["isTfnForm"] = false;
  }
  
  const candidateDataRess = await dispatch<any>(
    checkIsSignedorNot(obj)
  );

  let specialFormIndex = null;

  if(candidateDataRess && candidateDataRess?.payload && candidateDataRess?.payload?.data){
    let docsPayload = candidateDataRess?.payload?.data?.message;
    
    if(isSuperFormData?.length > 0){
      specialFormIndex = superFormIndex;
    }else if(isTFNFormData?.length > 0){
      specialFormIndex = tfnFormIndex;
    }
    

    if(docsPayload === "Form Signed"){

      if(isSuperFormData?.length > 0){
        setIsSuperSigned(true);
        setSuperSigningUrl("");
      }else if(isTFNFormData?.length > 0){
        setIsSigned(true);
        setSigningUrl("");
      }
      let formData = updateFormData;
      let currentFormIndex = specialFormIndex;
      let previousFormIndex = specialFormIndex !== null ? specialFormIndex - 1 : 0;
      let nextFormIndex = specialFormIndex !== null ? specialFormIndex + 1 : 0;

      if(specialFormIndex !== null && formData.length === (specialFormIndex + 1)){
        

        if (currentFormIndex !== null && formData[currentFormIndex]) {
          formData[currentFormIndex].active = true;
          formData[currentFormIndex].currentPage = true;
        }
      }else{
        if (nextFormIndex !== null && formData[nextFormIndex]) {
          formData[nextFormIndex].active = true;
          formData[nextFormIndex].currentPage = true;
        }

        if(currentFormIndex !== null && formData[currentFormIndex]){
          formData[currentFormIndex].active = false;
          formData[currentFormIndex].currentPage = false;
          formData[currentFormIndex].completedPage = "true";
          
          document.body.classList.remove("tfnForm");
          
        }

        
      }

      if(nextFormIndex === superFormIndex){
        document.body.classList.add("theme-form-id1");
        document.getElementById("personal-details-" + nextFormIndex)?.classList.replace("d-none", "d-flex");
      }

    
      setUpdateFormData(formData);
      setIsTFNFormChanges(false); // When submitting it from iframe page, we need to pass isTFNFormChanged as 0 to create pdf file in API side.
      setIsSuperFormChanges(false); // When submitting it from iframe page, we need to pass isSuperForm

      if(specialFormIndex !== null && formData.length === (specialFormIndex + 1)){
        setIsLastPage(true);
        setFileUploadValue(100);
      }
    }else{
      toast("Please sign the document.", {
        type: "error",
        autoClose: 60000,
      });
    }
  }

};


const showEditTFNForm = async (): Promise<void> => {
  setSigningUrl("");
  setSignedUrl("");
  setIsSigned(false);
  isEditFormDocSigned(candidateId, true);
  let formData = updateFormData;
  let tfnFormPosition = formData.findIndex((ress: any) => ress?.isTFNForm === 1);
  formData.forEach((element: any, index: number) => {
    if (element?.isTFNForm === 1) {
      formData[index].active = true;
    }else{
      formData[index].active = false; // disabling other forms
    }
  });

  setIsTFNFormChanges(false); // set false here because when click edit tfn form button and without doing edit it will always TRUE because of previous state, to reset it to false
  setUpdateFormData(formData);
  document.getElementById("personal-details-" + tfnFormPosition)?.classList.replace("d-none", "d-flex");
  document.body.classList.add("tfnForm");
  return;
};

const showEditSuperForm = async (): Promise<void> => {
  setSuperSigningUrl("");
  setSuperSignedUrl("");
  setIsSuperSigned(false);
  await isEditFormDocSigned(candidateId, false, true);
  let formData = updateFormData;
  let superFormPosition = formData.findIndex((ress: any) => ress?.isSuperForm === 1);
  formData.forEach((element: any, index: number) => {
    if (element?.isSuperForm === 1) {
      formData[index].active = true;
    }else{
      formData[index].active = false; // disabling other forms
    }
  });

  setIsSuperFormChanges(false); // set false here because when click edit tfn form button and without doing edit it will always TRUE because of previous state, to reset it to false
  setUpdateFormData(formData);
  document.getElementById("personal-details-" + superFormPosition)?.classList.replace("d-none", "d-flex");
  document.body.classList.add("theme-form-id1");
  return;
};

  useEffect(() => {
    if (candidateData?.statusCode === 200) {

      if (!document.body.classList.contains("onboarding")) {
        document.body.classList.add("onboarding");
      }
      
      const navigateTo = sessionStorage.getItem("navigateTo");
      if (navigateTo === null || navigateTo === undefined || navigateTo === "") {
        sessionStorage.setItem("navigateTo", candidateData?.currentPage);
      }
      // sessionStorage.setItem("navigateTo", candidateData?.currentPage);

      // if(candidateData?.signingUrl !== "" &&  candidateData?.completionPercentage !== "0%"){
      // if(candidateData?.signingUrl !== ""){
      //   const singed_iframe_url = candidateData?.signingUrl;
      //   localStorage.setItem("signed_url",singed_iframe_url);
      //   setSigningUrl(singed_iframe_url);
      // }

      setIsLastPage(candidateData?.data.length <= candidateData?.currentPage);
      setCountControl((prs) => {
        return {
          ...prs,
          show: false,
          timelineUpdate: false
        };
      });
      setScreenShort((prs) => {
        return {
          ...prs,
          active: true,
        };
      });
      if (
        (candidateData?.currentPage === -2 ||
        candidateData?.currentPage === "-2")
      ) {
        navigate("/getCandidate/onboarding-result");
        dispatch(loderControl());
      } else if (
        (candidateData?.currentPage === "-1" ||
        candidateData?.currentPage === -1) && (isTfnForm !== 1)
      ) {
        navigate(`/getCandidate/${sessionStorage.getItem("clientId")}`);
        dispatch(loderControl());
      } else if(isTfnForm === 1){
        dispatch(loderOffControl());
      } else {
        // setTimeout(() => {
        dispatch(loderOffControl());
        // }, 5000);
      }
      const candidateDataRess = { ...candidateData };
      candidateDataRess["finalStep"] =
        candidateDataRess["finalStep"] === null
          ? 0
          : candidateDataRess["finalStep"];
      if (sessionStorage.getItem("navigateTo")) {
        candidateDataRess["currentPage"] = Number(
          sessionStorage.getItem("navigateTo")
        );
      }

      let tfnFormPosition: number | null = null;
      let superFormPosition: number | null = null;

      candidateDataRess?.data?.forEach((ress: any, j: number) => {     
        if(ress.isTFNForm === 1){
          setTfnFormIndex(j);
          tfnFormPosition = j;
        }

        if(ress.isSuperForm === 1){
          setSuperFormIndex(j);
          superFormPosition = j;
          
        }
      });

      if(tfnFormPosition !== null && candidateData?.currentPage !== tfnFormPosition + 1){
        setSigningUrl("");// to avoid shoing iframe in the other forms
        setSignedUrl("");
      }

      if(superFormPosition !== null && candidateData?.currentPage !== superFormPosition+1){
        setSuperSigningUrl("");// to avoid shoing iframe in the other forms
        setSuperSignedUrl("");
      }

      const modifideFormData = candidateDataRess?.data.map(
        (data: any, i: number) => {
          const indata: any = {};
          const control = { ...data };
          control.index = i;          
          control.active = false;

          // if(data?.isTFNForm === 1 && data.active === true){
          //   document.body.classList.add("tfnForm"); 
          //   setIsTfnForm(1);
          // } 

          control.currentPage = false;
          control.currentPageStyle = "";

          if (
            (candidateDataRess?.currentPage === "-1" && i === 0) ||
            (i === 0 && candidateDataRess?.currentPage === 1)
          ) {
            control.active = true;
            control.currentPage = true;
            control.currentPageStyle = "current-page";
          } else if (candidateDataRess?.currentPage > i + 1) {
            // if(isTfnForm !== 1){
            //   control.completedPage = true;
            // }else{
            //   control.active = true;
            //   control.currentPage = true;
            // }
            control.completedPage = true;
            
            control.currentPageStyle = "current-page";
          } else if (candidateDataRess?.currentPage === i + 1) {
            if(signingUrl !== "" && signingUrl !== null && tfnFormPosition !== null && candidateDataRess.currentPage === (tfnFormPosition+1)){
              control.active = false;
              // control.currentPageStyle = "current-page";
              control.currentPage = true;
              
            }else if(superSigningUrl !== "" && superSigningUrl !== null && superFormPosition !== null && candidateDataRess.currentPage === (superFormPosition+1)){
              control.active = false;
              control.currentPage = true;

            } else if(superSignedUrl !== "" && superSignedUrl !== null && superFormPosition !== null && candidateDataRess.currentPage === (superFormPosition+1)){
              control.active = false;
              control.currentPage = true;

            }else{
              control.active = true;
              // control.currentPageStyle = "current-page";
              control.currentPage = true;
            }
            
          }

          if (candidateDataRess?.finalStep > i + 1 ) {
            if(isTfnForm !== 1){
              control.currentPageStyle = "current-page";
              control.completedPage = true;
            }else{
              //control.currentPage = true;
            }
            

          } else if (candidateDataRess?.currentPage === i + 1) {
            control.currentPageStyle = "current-page";
          }

          if(candidateDataRess?.currentPage === i +1){
            if(signingUrl !== "" && tfnFormPosition === i){
              control.currentPage = true;
            }else if(superSigningUrl !== "" && superFormPosition === i){
              control.currentPage = true;
            }else{
              control.currentPage = true;
            }
            
          }

          
          if(control?.isTFNForm === 1){
            if(signingUrl !== "" && tfnFormPosition === i){
              control.completedPage = false; // to fix the time line issue when showing iframe
            }
            if(signingUrl !== undefined && signingUrl !== "" && tfnFormPosition === i && candidateDataRess.currentPage === (tfnFormPosition+1)){
              document.getElementById("personal-details-"+tfnFormPosition)?.classList.add("d-none"); 
              control.active = true;
            }else if(tfnFormPosition === i && signingUrl === "" && data?.active === true){
              document.getElementById("personal-details-"+tfnFormPosition)?.classList.replace("d-none", "d-flex");
              
              if(valudatesetformstatus === "draft"){
                control.active = true; 
                setSigningUrl(""); // Added because when user click on save and exit button when it display iframe we need to show TFN form and hide the iframe.
              }
            }
          }else if(control?.isSuperForm === 1){
            if(superSigningUrl !== "" && superFormPosition === i){
              control.completedPage = false; // to fix the time line issue when showing iframe
            }
            if(superSigningUrl !== undefined && superSigningUrl !== "" && superFormPosition === i && candidateDataRess.currentPage === (superFormPosition+1)){
              document.getElementById("personal-details-"+superFormPosition)?.classList.add("d-none"); 
              control.active = true;
            }else if(superFormPosition === i && superSigningUrl === "" && data?.active === true){
              document.getElementById("personal-details-"+superFormPosition)?.classList.replace("d-none", "d-flex");
              
              if(valudatesetformstatus === "draft"){
                control.active = true; 
                setSuperSigningUrl(""); // Added because when user click on save and exit button when it display iframe we need to show TFN form and hide the iframe.
              }
            }
          }

          if(signingUrl === "" && tfnFormPosition === i && candidateDataRess.currentPage === (tfnFormPosition+1)){
            document.getElementById("personal-details-"+tfnFormPosition)?.classList.replace("d-none", "d-flex");
            document.body.classList.remove("theme-form-id1");
          }

          if(superSigningUrl === "" && superFormPosition === i && candidateDataRess.currentPage === (superFormPosition+1)){
            document.getElementById("personal-details-"+superFormPosition)?.classList.replace("d-none", "d-flex");
            document.body.classList.remove("tfnForm");
          }

          

          

          // if(tfnFormPosition === i && isTFNFormChanges === true){
          //   setIsTFNFormChanges(false); // It was set when navigating from previous form
          // }
          
          // if(tfnFormPosition !== null && (tfnFormPosition + 1) === candidateDataRess?.currentPage && candidateDataRess.signingUrl === ""){
          //   document.getElementById("personal-details-"+tfnFormPosition)?.classList.remove("d-none"); 
          //   document.getElementById("personal-details-"+tfnFormPosition)?.classList.add("d-flex"); 
          //   control.active = true;
          // }

          // if(tfnFormIndex === i && candidateDataRess?.data?.length === 1){

          // }

          
         

          const sunFormIndate1: any = [];
          const sunFormIndate2: any = [];
          const sunFormIndate3: any = [];

          let sunIndexIndateCount = 0;
          const formFields = control?.fields?.map((element: any) => {
            const element1 = { ...element };
            if (element.firstName) {
              localStorage.setItem("clindFirstName", element.value);
            }

            if(element?.isSignature === true){
              // setCandidateSignModel(element?.value);
              setCandidateSignModel(prev => ({
                ...prev,
                [element?.name]: element?.value,
              }));
            }
            // get subform 1 value
            if (element?.subForm && element.name === "subForm-1") {
              const obj: any = {};
              element.subForm.forEach((item: any, i: number) => {
                if (item.type === "date") {
                  if (item.value) {
                    obj[item.name] = new Date(item.value);
                  } else {
                    obj[item.name] = item.value;
                  }
                } else {
                  if (item.type === "file") {
                    obj[item.name] = item.value;
                    oldFile[`subForm_1.${sunIndexIndateCount}.${item.name}`] =
                      item.value;
                  } else {
                    obj[item.name] = item.value;
                  }
                }
              });
              sunFormIndate1.push(obj);
              sunIndexIndateCount = sunIndexIndateCount + 1;
              indata.subForm_1 = sunFormIndate1;
            }
            //  get subform 2 value
            if (element?.subForm && element.name === "subForm-2") {
              const obj: any = {};
              element.subForm.forEach((item: any, i: number) => {
                if (item.type === "date") {
                  if (item.value) {
                    obj[item.name] = new Date(item.value);
                  } else {
                    obj[item.name] = item.value;
                  }
                } else {
                  if (item.type === "file") {
                    const subFormIndex1 = control?.fields.filter(
                      (ress: any) => ress.name === "subForm-1"
                    );
                    obj[item.name] = item.value;
                    oldFile[
                      `subForm_2.${sunIndexIndateCount - subFormIndex1.length
                      }.${item.name}`
                    ] = item.value;
                  } else {
                    obj[item.name] = item.value;
                  }
                }
              });
              sunFormIndate2.push(obj);
              sunIndexIndateCount = sunIndexIndateCount + 1;
              indata.subForm_2 = sunFormIndate2;
            }

            //  get subform 3 value
            if (element?.subForm && element.name === "subForm-3") {
              const obj: any = {};
              element.subForm.forEach((item: any, i: number) => {
                if (item.type === "date") {
                  if (item.value) {
                    obj[item.name] = new Date(item.value);
                  } else {
                    obj[item.name] = item.value;
                  }
                } else {
                  if (item.type === "file") {
                    const subFormIndex1 = control?.fields.filter(
                      (ress: any) => ress.name === "subForm-1"
                    );
                    obj[item.name] = item.value;
                    oldFile[
                      `subForm_3.${sunIndexIndateCount - subFormIndex1.length
                      }.${item.name}`
                    ] = item.value;
                  } else {
                    obj[item.name] = item.value;
                  }
                }
              });
              sunFormIndate3.push(obj);
              sunIndexIndateCount = sunIndexIndateCount + 1;
              indata.subForm_3 = sunFormIndate3;
            }

            if (element.type === "date") {
              if (element.value) {
                indata[element.name] = new Date(element.value);
              } else {
                indata[element.name] = element.value;
              }
            } else if (element.type === "radio-group") {
              if (element?.is_child_validate === null) {
                childDisplay = {
                  parentName: element.name,
                  child_display: element.child_display?.map((ress: any) => {
                    return ress.child_display_id;
                  }),
                  visibleArray: element.child_display,
                  hideName: null,
                };
              }
              indata[element.name] = element.value;
            } else if (element.type === "select") {
              if (element.is_child_validate) {
                if(element?.child_validate?.parent_validate_value){
                  checkValidationElement.push({
                    parent_value: element.child_validate.parent_validate_value,
                    child_name: element.child_validate.child_validate_id,
                    parent_name: element.name,
                  });
                }
                if(element?.child_display && element.child_display.length > 0){
                  childDisplay = {
                    parentName: element.name,
                    child_display: element.child_display?.map((ress: any) => {
                      return ress.child_display_id;
                    }),
                    visibleArray: element.child_display,
                    hideName: null,
                  };
                }
              }
              indata[element.name] = element.value;
            } else if(element.type === "multiSelect"){
              if (element.is_child_validate) {
                if(element?.child_display) {
                    checkValidationElement.push({
                      parent_value: element.child_display.map((e: any) => e?.parent_validate_value),
                      child_name: element.child_display[0].child_display_id,
                      parent_name: element.name,
                  });
                }
              }
              indata[element.name] = element.value;
            }
            else if (element.type === "split-input") {
              if (element.validate) {
                indata[`${element.name}-0`] = element.value;
              }

              if(element.value){
                const splitLength = Array(element?.boxCount).fill(null);
                splitLength.forEach((_: any, index: number) => {
                  indata[`${element.name}-${index}`] = element.value[index];       
                });

              }
              indata[element.name] = element.value;
            } else if (element.type === "file") {
              indata[element.name] =
                element.value !== undefined ? element.value : [];
              oldFile[element.name] =
                element.value !== undefined ? element.value : [];
            } else {
              if (element.type === "iframe") {
                const obj = { ...element };
                obj.index = i;
                indata[element.name] = element.value;
                setIframeData((prs: any) => {
                  return {
                    ...prs,
                    data: [...prs.data, obj],
                  };
                });
              } else {
                if (element?.firstName && !element.value) {
                  indata[element.name] =
                    candidateData?.candidateDetails?.firstName;
                  element1["value"] = candidateData?.candidateDetails?.firstName;
                } else if (element?.lastName && !element.value) {
                  indata[element.name] =
                    candidateData?.candidateDetails?.lastName;
                  element1["value"] = candidateData?.candidateDetails?.lastName;
                } else if (element?.fullName && !element.value) {
                  indata[element.name] =
                    candidateData?.candidateDetails?.fullName;
                  element1["value"] = candidateData?.candidateDetails?.firstName + " " + candidateData?.candidateDetails?.lastName;
                } else if (element?.email && !element.value) {
                  indata[element.name] = candidateData?.candidateDetails?.email;
                  element1["value"] = candidateData?.candidateDetails?.email;
                } else if (element?.phone && !element.value) {
                  indata[element.name] = candidateData?.candidateDetails?.phone;
                  element1["value"] = candidateData?.candidateDetails?.phone;
                } else if (element?.positionApplied && !element.value) {
                  indata[element.name] = candidateData?.candidateDetails?.jobName + " (" + candidateData?.candidateDetails?.jobReferenceId + ")";
                  element1["value"] = candidateData?.candidateDetails?.jobName + " (" + candidateData?.candidateDetails?.jobReferenceId + ")";
                } else if (
                  element.name !== "subForm-1" &&
                  element.name !== "subForm-2" && 
                  element.name !== "subForm-3"
                ) {
                  indata[element.name] = element.value;
                }
              }
            }
            return element1;
          });
          return { ...control, indata: indata, fields: formFields };
        }
      );
      
      // modifideFormData
      //   .filter((data: any) => data?.isTFNForm === 1 && data.active === true)
      //   .forEach((data: any) => {
      //     document.body.classList.add("tfnForm");
      //     setIsTfnForm(1);
      //   });

        modifideFormData.forEach((element: any, index: number) => {
          if(element?.isTFNForm === 1 && element.active === true){
            document.body.classList.add("tfnForm"); 
            setIsTfnForm(1);
          }

          if(element?.isSuperForm === 1 && element.active === true){
            document.body.classList.add("theme-form-id1"); 
            setIsSuperForm(1);
          }

          
        });

        let tfnForm = modifideFormData.filter((data: any) => data?.isTFNForm === 1 && data.active === true);
        if(tfnForm.length === 0){
          document.body.classList.remove("tfnForm"); 
        }else{
          document.body.classList.add("tfnForm"); 
        }

        let superForm = modifideFormData.filter((data: any) => data?.isSuperForm === 1 && data.active === true);
        if(superForm.length === 0){
          document.body.classList.remove("theme-form-id1"); 
        }else{
          document.body.classList.add("theme-form-id1"); 
        }
        
        // if(isSigned){
        //   document.body.classList.remove("tfnForm"); 
        // }
      
      setUpdateFormData(modifideFormData);
    } else if (candidateData?.statusCode === 403) {
      handleExpiredLink(candidateData);
    } else if (candidateData === null || candidateData?.statusCode === 400) {
      navigate("*");
    }
  }, [candidateData]);

  useEffect(() => {
    if (candidateDataDocuments !== null) {
      if (handleExpiredLink(candidateDataDocuments)) {
        return;
      }
      if (candidateDataDocuments.status === 200) {
        const obj: any = {};
        obj["clientId"] = sessionStorage.getItem("clientId");
        obj["domainWithHttp"] = domainWithHttp;
        dispatch<any>(
          getCandidateData(obj)
        );

        // if(isTfnForm === 1 && candidateDataDocuments?.data?.signingUrl?.length > 0){
        //   setSigningUrl(candidateDataDocuments?.data?.signingUrl);
        // }

        // if(isTfnForm === 1 && candidateDataDocuments?.data?.signedUrl?.length > 0){
        //   setSignedUrl(candidateDataDocuments?.data?.signedUrl);
        // }

        // if(isTfnForm === 1 && candidateDataDocuments?.data?.isSigned){
        //   setIsSigned(candidateDataDocuments?.data?.isSigned);
        // }
      }
    }
  }, [candidateDataDocuments]);

  const candidateSignatures = (signData: any) => {
    // const signElement = document.getElementsByName(signData);
    // if (signElement) {
    //   setCandidateSignModel((signElement[0] as HTMLInputElement).value);
    // }    
    const signElement = document.getElementsByName(signData);
    if (signElement && signElement[0]) {
      setCandidateSignModel(prev => ({
        ...prev,
        [signData]: (signElement[0] as HTMLInputElement).value,
      }));
    }
  };

  const fileNameModifide = (fileData: any) => {
    const aaaWithoutExtension = fileData?.file?.name.replace(/\.[^.]+$/, "");
    let result = "";
    if (aaaWithoutExtension?.length > 30) {
      const lastDotIndex = fileData?.file?.name?.toString()?.lastIndexOf(".");
      const extension = fileData?.file?.name?.substring(lastDotIndex + 1);
      const prifix = fileData?.file?.name?.substring(0, 15);
      const subfix = aaaWithoutExtension?.slice(-10);
      result = prifix + "..." + subfix + "." + extension;
    } else {
      result = fileData?.file?.name;
    }
    return result;
  };

  const deleteFilesFromServer = async () => {
    const pathParamObj:any = {};
    pathParamObj["clientId"] = sessionStorage.getItem("clientId");
    pathParamObj["domainWithHttp"] = domainWithHttp;
    const response = await apiPost(endPoint.deleteFile, {fileUrl:getFilesForDeletion}, pathParamObj);
    return response;
  };

  // Extracts anchor links from an HTML string
  const extractLinksFromHtml = (html: string): { name: string; url: string }[] => {
      const links: { name: string; url: string }[] = [];
      const parser = new DOMParser();
      const parsed = parser.parseFromString(html, "text/html");
      parsed.querySelectorAll("a").forEach((a) => {
          const url = a.getAttribute("href")?.trim() || "";
          const name = a.textContent?.trim() || url;
          if (url) {links.push({ name, url });}
      });
      return links;
  };

  const exportPDF = async (params: any, index: any) => {
    const doc = new jsPDF();
    // Add custom font
    doc.addFileToVFS("Allura-Regular.ttf", alluraFont);
    doc.addFont("Allura-Regular.ttf", "Allura", "normal");
    const pdfTable = params.filter((ress: any) => ress.active)[0];
    const tableBody: any = [];
    //insert main label
    tableBody.push([{ content: pdfTable.label, styles: { fontStyle: "bold" } }, ""]);

    // const baseUrl = process.env.REACT_APP_API_BASE_URL + "download?FileUrl=";
    const baseUrl = `${process.env.REACT_APP_API_BASE_URL}download?domainWithHttp=${encodeURIComponent(domainWithHttp)}&FileUrl=`;
    //get current time stamp
    let currDate = new Date();
    let currYear = currDate.getFullYear();
    let currMonth = currDate.getMonth() + 1;
    let currDay = currDate.getDate();
    let currHours = currDate.getHours();
    let currMinutes = currDate.getMinutes();
    let currSeconds = currDate.getSeconds();
    let headerText = "Document created on : "+ currDay.toString().padStart(2, "0") + "-" + currMonth.toString().padStart(2, "0") + "-" + currYear + " " + currHours + ":" + currMinutes + ":" + currSeconds;
    let iFrameText = "";
    pdfTable?.fields?.forEach((element: any) => {
      if (element.type === "date") {
        if (element.value) {
          const date =
            element.value.getDate().toString().padStart(2, "0") +
            "-" +
            (element.value.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            element.value.getFullYear();
          tableBody.push([element.pdfLabel, date]);
        }
      }
      //add titles for each section 
      else if(element.type === "html" && element.value === "" && element?.lableClass !== "d-none"){
        tableBody.push([{ content: element.label, styles: { fontStyle: "bold" } }, ""]);
      }else if (element.type === "html" && element.value) {
        const links = extractLinksFromHtml(element.value);
        if (links.length > 0) {
            tableBody.push([element.label || "", { items: links, type: "file-url" }]);
        }
      } else if (element?.isSignature === true) {
        tableBody.push([element.pdfLabel, {
          item: element.value,
          type: "signature",
        }]);
      } else if (element.type === "file") {
        const fileName: any[] = [];
        if (element?.value.length > 0) {
          element?.value.forEach(async (tt: any, rowIndex: any) => {
            // console.log(88888, tt);

            const result = fileNameModifide(tt);
            fileName.push({
              name: result,
              url: `${baseUrl}${tt.file.url}`, //ress.file.url,
            });
          });
          tableBody.push([
            element.pdfLabel,
            {
              items: fileName,
              type: "file-url",
            },
          ]);
        } else {
          tableBody.push([element.pdfLabel, ""]);
        }
      } else if (
        element.type === "checkbox-group" ||
        element.type === "checkbox"
      ) {
        if (element.label) {
          tableBody.push([element.pdfLabel, element.value]);
        } else {
          tableBody.push([element.values[0].label, element.value]);
        }
      } else if (
        element.type === "multiSelect"
      ) {
        const multiSelectValue = element.value.map((item: any) => item.value).join(", ");
        if (element.label) {
          tableBody.push([element.pdfLabel, multiSelectValue]);
        } else {
          tableBody.push([element.values[0].label, multiSelectValue]);
        }
      } 
      else if (element.name === "subForm-1" || element.name === "subForm-2" || element.name === "subForm-3") {
        element.subForm.forEach((item: any) => {
          if (item.type === "text") {
            tableBody.push([item.pdfLabel, item.value]);
          } else if (item.type === "date") {
            if (item.value) {
              const date =
              item.value.getDate().toString().padStart(2, "0") +
                "-" +
                (item.value.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                item.value.getFullYear();
              tableBody.push([item.pdfLabel, date]);
            }else{
              tableBody.push([item.pdfLabel, ""]);
            }
          } else {
            const fileName: any = [];
            if (Array.isArray(item.value)) {
              item.value.forEach((ress: any) => {
                const result = fileNameModifide(ress);
                fileName.push({
                  name: result,
                  url: `${baseUrl}${ress.file.url}`, //ress.file.url,
                });
              });

              tableBody.push([
                item.pdfLabel,
                {
                  items: fileName,
                  type: "file-url",
                },
              ]);
            } else {
              tableBody.push([item.pdfLabel, item.value]);
            }
          }
        });
      }else if(element.type === "text" && element.subtype === "make-bold"){
        tableBody.push([{
          items: [{"name": element.pdfLabel, "url" : ""}],
          type: "make-bold",
        }, ""]);
      } else if (element.type !== "iframe" && element.type !== "hr" && element.type !== "html") {
        tableBody.push([element.pdfLabel, element.value]);
      }
      if(element.type === "iframe" && element.iframe_url !== ""){
        iFrameText = element.iframe_url;
      }
    });
    const tableStyles = {
      fillColor: candidateData?.clientDetails.brandColor,
      fontStyle: "bold",
      fontSize: 10,
    };
    const links = [];

    autoTable(doc, {
      head: [["Label", "Value"]],
      body: tableBody,
      headStyles: tableStyles as any,
      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 100 }

      },
      

      didParseCell: (data) => {
       
        if (data.section === "body" && data.column.index === 1) {
          const signURLData = data?.cell?.raw as SignExportTableUrlData;
          if(signURLData?.type === "signature"){
            data.cell.styles.font = "Allura";
            data.cell.text = [signURLData?.item || ""];
          }else{
            data.cell.styles.font = "helvetica";
          }
          if (data?.cell?.raw && typeof data.cell.raw === "object" && Object.hasOwn(data.cell.raw, "type")) {
            const urlData = data.cell.raw as ExportTableUrlData;
            if (urlData.type === "file-url") {
              const n = urlData.items.length;
              if (n > 1) {
                const currentHeight = 5;
                data.cell.styles.minCellHeight = currentHeight * n + 2;
                data.cell.styles.cellWidth = 100;
                data.cell.styles.minCellWidth = 100;
                data.cell.styles.overflow = "hidden";
                data.row.height = currentHeight * n + 2;
              }
              data.cell.text = [""];
            }
          }
        }else if(data.section === "body" && data.column.index === 0){
          // if (Object.prototype.hasOwnProperty.call(data.cell.raw, "type")) {
          if (data?.cell?.raw && typeof data.cell.raw === "object" && Object.hasOwn(data.cell.raw, "type")) {
            const urlData = data.cell.raw as ExportTableUrlData;
            if(urlData.type === "make-bold"){
              data.cell.styles.fontStyle = "bold";
              data.cell.text = [urlData.items[0].name];              
            }
        }
        }
      },

      didDrawCell: (data) => {
        if (data.section === "body" && data.column.index === 1) {
          // if (Object.prototype.hasOwnProperty.call(data.cell.raw, "type")) {
          if (data?.cell?.raw && typeof data.cell.raw === "object" && Object.hasOwn(data.cell.raw, "type")) {
            const urlData = data.cell.raw as ExportTableUrlData;
            if (urlData.type === "file-url") {
              let yPos = 5;
              doc.setTextColor("#0563C1");
              urlData.items.forEach((itm) => {
                const x = data.cell.x + 1;
                const y = data.cell.y + yPos;
                doc.textWithLink(
                  itm.name,
                  x,
                  y,
                  { url: itm.url }
                );
                const textWidth = doc.getTextWidth(itm.name);
                doc.line(x, y + 0.5, x + textWidth, y + 0.5);
                yPos += 5;
              });
              doc.setTextColor(0);
            }
          }
        }
      },
      didDrawPage: (data) => {
        doc.setFontSize(8);
        doc.text(headerText, data.settings.margin.left, 10);
        // if(iFrameText !== ""){
        //   doc.text("Attached Document URL:", 10, 20);
        //   doc.textWithLink(pdfTable?.label, 60, 20, { url: iFrameText });
        // }

      },
    });
    
    
    // Iframe url link to see attached document
    if(iFrameText !== ""){
      const displayText = pdfTable?.label;
      const finalY = (doc as any).lastAutoTable.finalY + 15; // 15 units below the table
      doc.setTextColor("#0563C1");
      doc.textWithLink("View Info : " + displayText, 15, finalY, { url: iFrameText, underline: true });
    }

    // doc.save("table.pdf");
    const pdfDataUri = doc.output("datauristring");
    return await pdfDataUri;
  };
  
  const finalUserInput = (splitLength : any, name : any) => {
    const values: any[] = [];
    splitLength.forEach((_: any, index: number) => {
        const element = document.getElementById(`${name}-${index}`);
        const fieldInputValue : any = element ? (element as HTMLInputElement).value : "";
        if(fieldInputValue !== ""){
            values.push(fieldInputValue);
        }else {
            values.push(" ");
        }
    });
    return values.join("").toUpperCase().trim();
};


  const clearValueForChildElement = () => {
    setClearChilInput(true);
  };

  // Check parent value match for child display
  const checkParentMatch = (data: any, formikValues: any) => {
    const fieldValue = formikValues?.[data.parentName] || [];
    // console.log("formikValues", formikValues);
    // console.log("data", data);
    // console.log("fieldValue", fieldValue);
    // Case 1: Multi select
    if (Array.isArray(data.parentValues) && Array.isArray(fieldValue)) {
      // extract only the values from [{label, value}, ...]
      const selectedValues = fieldValue.map((item: any) => item.value);

      // check if ANY of the parentValues exist in selectedValues
      return data.parentValues.some((val: string) => selectedValues.includes(val));
    }
    // Case 2: Single select or text
    if (data.parentValue) {
      return fieldValue === data.parentValue;
    }
    // Case 3: Single select with multiple parentValues
    if (Array.isArray(data.parentValues)) {
      return data.parentValues.includes(fieldValue);
    }

    return true; // by default show the field if no specific condition is set
  };


  const submitCandidateData = async (params: any) => {
    if (formstatusTwo) {
      formstatus = "draft";
    } else {
      sessionStorage.removeItem("navigateTo");
    }
    setFileUploadValue(0);
    const fd = new FormData();
    let base64Image: any = null;
    let tfnFormIndex: number | null = null;
    let superFormIndex: number | null = null;
    let isActiveTfnFormSubmit = false;
    let isActiveSuperFormSubmit = false;

   
        
    params?.forEach((ress: any, i: number) => {     
      if(ress.active === true && ress.isTFNForm === 1){
        tfnFormIndex = i;
        setTfnFormIndex(i);
        isActiveTfnFormSubmit = true;
      }

      if(ress.active === true && ress.isSuperForm === 1){
        superFormIndex = i;
        setSuperFormIndex(i);
        isActiveSuperFormSubmit = true;
      }
    });
    

    /* Placed here because we need to get the value of the split input fields before the form is submitted */
    params?.forEach((ress: any, i: number) => {
      if(ress?.fields?.length > 0 && ress?.active === true){
        ress.fields.forEach((fieldList: any, k: number) => {
          if(fieldList?.type === "split-input"){
            const splitLength = Array(fieldList?.boxCount).fill(null);
            const finalUserValue = finalUserInput(splitLength, fieldList?.name);
            if(fieldList?.name){
              fd.append(fieldList?.name, finalUserValue);
              if (ress?.fields) {
                if (tfnFormIndex !== null && params[tfnFormIndex]?.fields[k]) {
                  params[tfnFormIndex].fields[k].value = finalUserValue;
                } else if(superFormIndex !== null && params[superFormIndex]?.fields[k]){
                  params[superFormIndex].fields[k].value = finalUserValue;
                }
              }
            }
            
          }
        });

      }
    });
    
    if(isSigned){
      setIsTFNFormChanges(false); // When submitting it from iframe page, we need to pass isTFNFormChanged as 0 to create pdf file in API side.
    }

    if(isSuperSigned){
      setIsSuperFormChanges(false); // When submitting it from iframe page, we need to pass isSuperFormChanged as 0 to create pdf file in API side.
    }
    
    // get super form id
    let flkTemplateName = "";
    if(superFormIndex !== null){
      params?.[superFormIndex]?.fields.filter((ress: any) => ress?.superFormTemplateId === 1).forEach((ress: any, i: number) => {
        let selectOptionArr = (ress?.values.filter((options: any) => options?.value === ress?.value)?.[0]);
        if(selectOptionArr){
          fd.append("flkTemplateName", selectOptionArr?.tfnTemplateName);
        }else{
          fd.append("flkTemplateName", flkTemplateName);
        }
        // if(ress?.values.filter((options: any) => options?.value === ress?.value)?.[0].length > 0){
        //   fd.append("flkTemplateName", ress?.tfnTemplateName);
        // }        
        
      });
    }else{
      fd.append("flkTemplateName", flkTemplateName);
    }

    // return;
    params?.forEach(async (ress: any, i: number) => {      
      if (ress.active) {
        if (formstatus === "draft") {

          fd.append("formStatus", "draft");
        } else {
                  console.log("[submitCandidateData] calling exportPDF with params:", params, "i:", i);

          base64Image = await exportPDF(params, i);
                  console.log("[submitCandidateData] exportPDF returned base64Image:", base64Image?.substring?.(0, 100));

          if(ress.isTFNForm !== 1 && ress.isSuperForm !== 1){
            fd.append(
              "formStatus",
              updateFormData.length !== i + 1 ? "submit" : "complete"
            );
          }else{

            if(ress.isTFNForm === 1){
              if(isSigned && ress.isTFNForm === 1){
                if(isLastPage){
                  fd.append(
                    "formStatus",
                    "complete"
                  );
                }else{
                  if(params.length === 1 && isSigned && !isTFNFormChanges){
                    fd.append(
                      "formStatus",
                      "complete"
                    );
                  }else{
                    fd.append(
                      "formStatus",
                      "submit"
                    );
                  }
                  
                }
                
              } else if (signingUrl !== "" && ress.isTFNForm === 1 && isSigned === false) {
                fd.append(
                  "formStatus",
                  "submit"
                );
              }else{
                fd.append(
                  "formStatus",
                  "submit" 
                );
              }
            }else if(ress.isSuperForm === 1){
              if(isSuperSigned){
                if(isLastPage){
                  fd.append(
                    "formStatus",
                    "complete"
                  );
                }else{
                  if(params.length === 1 && isSuperSigned && !isSuperFormChanges){
                    fd.append(
                      "formStatus",
                      "complete"
                    );
                  }else{
                    fd.append(
                      "formStatus",
                      "submit"
                    );
                  }
                  
                }
                
              } else if (superSigningUrl !== "" && isSuperSigned === false) {
                fd.append(
                  "formStatus",
                  "submit"
                );
              }else{
                fd.append(
                  "formStatus",
                  "submit" 
                );
              }
            }else{
              fd.append(
                "formStatus",
                "submit" 
              );
            }
          }
        }

        // if(signedUrl !== "" && isTfnForm === 1){
        //   fd.append("currentPage", (i + 2)?.toString());
        // }else{
          fd.append("currentPage", (i + 1)?.toString());
        // }

        fd.append("isActiveTfnForm", ress.isTFNForm === 1 ? "1" : "0");
        if (ress.isTFNForm === 1) {
          fd.append("isTfnFormChanged", isTFNFormChanges ? "1" : "0");
        }else{
          fd.append("isTfnFormChanged", "0");
        }

        fd.append("isActiveSuperForm", ress.isSuperForm === 1 ? "1" : "0");
        if (ress.isSuperForm === 1) {
          fd.append("isSuperFormChanged", isSuperFormChanges ? "1" : "0");
        }else{
          fd.append("isSuperFormChanged", "0");
        }

        
        fd.append("candidateId", ress.candidateId);
        fd.append("clientId", ress.clientId);
        fd.append("formName", ress.label);
        fd.append(
          "finalStep",
          candidateData.finalStep === null ? 0 : candidateData.finalStep
        );
        // fd.append("finalStep", candidateData.finalStep === null ? 0 : candidateData.finalStep);
        fd.append("navigateTo", sessionStorage.getItem("navigateTo") || "");
        if (formstatus !== "draft") {
          // fd.append("pdfDoc", base64Image.split("data:image/jpeg;base64,")[1]);
          fd.append(
            "pdfDoc",
            base64Image.split(
              "data:application/pdf;filename=generated.pdf;base64,"
            )[1]
          );
        }
      }

      
    }); 

    
    fd.append("data", JSON.stringify(params));
   
    if (checkTimeline === "") {

      const candidateDataRess = await dispatch<any>(
        createCandidateDataDocuments(fd)
      );
      
      if (handleExpiredLink(candidateDataRess?.payload)) {
        return;
      }

      window.scrollTo(0, 0);
      let candidatePayload = candidateDataRess?.payload?.data?.data;
      if (formstatus === "draft" &&  candidateDataRess?.payload?.status === 200) {
        
        
        if(!isActiveTfnFormSubmit && !isActiveSuperFormSubmit){
          if (iframeData.sigcontrol) {
            setPageReload(true);
          } else {
            if (!saveToExitModel && !countControl.timelineUpdate) {
              setCountControl((prs) => {
                return {
                  ...prs,
                  saveDraftTest: true,
                  saveModel: true,
                };
              });
            }
            setPageReload(true);
          }
          setSigningUrl("");
          setSignedUrl("");
        }
      }else if(candidatePayload){
        if(candidatePayload?.signingUrl !== undefined && isActiveTfnFormSubmit){
          setSigningUrl(candidatePayload?.signingUrl);
          setSignedUrl(candidatePayload?.signedUrl);
          setIsSigned(candidatePayload?.isSigned);
          localStorage.setItem("signing_url", candidatePayload?.signingUrl);
          localStorage.setItem("signed_url", candidatePayload?.signedUrl);

          // let formData = updateFormData;
          // if (tfnFormIndex !== null) {
          //   formData[tfnFormIndex].active = false;
          // }
          // setUpdateFormData(formData);

        }else if(candidatePayload?.superSigningUrl !== undefined && isActiveSuperFormSubmit){
          setSuperSigningUrl(candidatePayload?.superSigningUrl);
          setSuperSignedUrl(candidatePayload?.signedUrl);
          setIsSuperSigned(candidatePayload?.superIsSigned);
          localStorage.setItem("signing_url", candidatePayload?.superSigningUrl);
          localStorage.setItem("signed_url", candidatePayload?.superSignedUrl);

        }else {
          setSigningUrl("");
          setSignedUrl("");
          setSuperSigningUrl("");
          setSuperSignedUrl("");
        }

        setIsSigned(candidatePayload?.isSigned);
        setCandidateId(candidatePayload?.candidateId);
        localStorage.setItem("is_signed", candidatePayload?.signedUrl);
      } else if(candidateDataRess?.payload?.data?.data?.signingUrl !== undefined){
        setIframeData((prs) => {
          return {
            ...prs,
            errorSign: true,
          };
        });

      } else {
        setScreenShort((prs) => {
          return {
            ...prs,
            saveModel: false,
          };
        });
      }
    }

  };
  useEffect(() => {
    if (movinIndex.indexClose) {
      let apiCall = 0;
      const fileObjIndex = 0;
      let controlApiCall = 1;
      const activeFormData: any = updateFormData.filter((ress) => ress?.active);
      const obj = { ...activeFormData[0] };
      const fData = new FormData();
      const pathParamObj:any = {};
      pathParamObj["clientId"] = sessionStorage.getItem("clientId");
      pathParamObj["domainWithHttp"] = domainWithHttp;
      fData.append("clientId", obj["clientId"]);
      fData.append("candidateId", obj["candidateId"]);
      fData.append("formId", obj["formId"]);
      if (totalFile.length > 0) {
        fData.append("fieldId", totalFile[0]["name"]);
        fData.append("files", totalFile[fileObjIndex]?.value[apiCall]);
      }
      const selectedFileupload = async () => {
        const response = await apiPost(
          endPoint.createCandidateDataDocuments,
          fData,
          pathParamObj
        );

        if (handleExpiredLink(response)) {
          setSaveModel(false);
          return;
        }

        if (response.status === 200) {
          controlApiCall = controlApiCall + 1;
          const obj = {
            parentName: totalFile[fileObjIndex]?.value[apiCall]["name"],
            url: response?.data?.data?.url[0],
            fileName: response?.data?.data?.fileName,
            childName: "",
          };
          apiCall = apiCall + 1;
          setTotalFile((oldArray: any) => [
            ...oldArray.map((ress: any) => {
              return ress;
            }),
          ]);

          if (controlApiCall >= movinIndex.fileIndex) {
            selectedFileupload();
          } else {
            setMovingIndex((prs) => {
              return {
                ...prs,
                indexClose: false,
              };
            });
          }
        }
      };
      if (movinIndex.indexClose) {
        selectedFileupload();
      }
    }
  }, [totalFile, movinIndex]);

  useEffect(() => {
    if (Math.round(fileUploadValue) >= 100) {
      setSaveModel(false);
      let subFormIndex = 0;

      const activeForm: any[] = updateFormData.filter(
        (ress) => (ress.active === true)
      );
      const activeFormIndex = updateFormData.findIndex((ress) => ress.active);

      let activePageNumber = (activeFormIndex ?? 0) + 1;

      let candidateId = updateFormData[0]?.candidateId;
      if(candidateId && signingUrl.length > 0 && !formstatusTwo){
        setFileUploadValue(0);
        const formName = activeForm[0]?.label || "";
        isDocSigned(candidateId, formName, activePageNumber);
        // if(updateFormData.length > 1){
        return;
        // }
      }

      if(candidateId && superSigningUrl?.length > 0 && !formstatusTwo){
        setFileUploadValue(prev => (prev === 0 ? prev : 0));
        const formName = activeForm[0]?.label || "";
        isDocSigned(candidateId, formName, activePageNumber);
        // if(updateFormData.length > 1){
        return;
        // }
      }


      let subForm3Index = 0;

      const sendData = updateFormData.map((ress, i) => {
        if ((changeParams && changeParams?.prsIndex === i) || ress.active) {
          const paramsData = formRef.current[i].values;
          
          // console.log("paramsData", paramsData);
          
          return {
            ...ress,
            fields: ress.fields.map((data, i) => {
              const obj = { ...data };
              if (obj?.subForm?.length > 0) {
                
                const subFormList = data?.subForm?.map(
                  (subData: any, j: number) => {
                    if (subData.type === "file") {
                      if (data.name === "subForm-1") {
                        const filterFile = uploadFileUrl.filter(
                          (gg: any) =>
                            gg?.file?.fieldId ===
                            `subForm_1.${subFormIndex}.${subData.name}`
                        );
                        const oldFileUrls = oldFile[
                          `subForm_1.${subFormIndex}.${subData.name}`
                        ]?.filter((aa: any) => !(aa instanceof File));
                        if (filterFile.length > 0) {
                          return {
                            ...subData,
                            value: oldFileUrls.concat(filterFile),
                          };
                        } else {
                          return {
                            ...subData,
                            value: oldFileUrls === undefined ? [] : oldFileUrls,
                          };
                        }
                      } else if (data.name === "subForm-3") {
                        const filterFile = uploadFileUrl.filter(
                          (gg: any) =>
                            gg?.file?.fieldId ===
                            `subForm_3.${subFormIndex}.${subData.name}`
                        );
                        const oldFileUrls = oldFile[
                          `subForm_3.${subFormIndex}.${subData.name}`
                        ]?.filter((aa: any) => !(aa instanceof File));
                        if (filterFile.length > 0) {
                          return {
                            ...subData,
                            value: oldFileUrls.concat(filterFile),
                          };
                        } else {
                          return {
                            ...subData,
                            value: oldFileUrls === undefined ? [] : oldFileUrls,
                          };
                        }
                      } else {
                        const filterFile = uploadFileUrl.filter(
                          (gg: any) =>
                            gg?.file?.fieldId ===
                            `subForm_2.${subFormIndex - paramsData.subForm_1.length
                            }.${subData.name}`
                        );
                        const oldFileUrls = oldFile[
                          `subForm_2.${subFormIndex - paramsData.subForm_1.length
                          }.${subData.name}`
                        ]?.filter((aa: any) => !(aa instanceof File));
                        if (filterFile.length > 0) {
                          return {
                            ...subData,
                            value: oldFileUrls.concat(filterFile),
                          };
                        } else {
                          return {
                            ...subData,
                            value: oldFileUrls === undefined ? [] : oldFileUrls,
                          };
                        }
                      }
                    } else {
                      if (data.name === "subForm-1") {
                        return {
                          ...subData,
                          value:
                            paramsData.subForm_1[subFormIndex][subData.name],
                        };
                      } else if (data.name === "subForm-3") {
                        return {
                          ...subData,
                          value:
                            paramsData.subForm_3[subForm3Index][subData.name],
                        };
                      } else {
                        return {
                          ...subData,
                          value:
                            paramsData.subForm_2[
                            subFormIndex - paramsData.subForm_1.length
                            ][subData.name],
                        };
                      }
                    }
                  }
                );

                if (data.name === "subForm-3") {
                  subForm3Index = subForm3Index + 1;
                }

                subFormIndex = subFormIndex + 1;
                return {
                  ...data,
                  subForm: subFormList,
                };
              } else {
                if (data.type === "file") {
                  const fileUrl: any = [];
                  if (uploadFileUrl.length > 0) {
                    const filterFile = uploadFileUrl.filter(
                      (gg: any) => gg?.file?.fieldId === obj.name
                    );
                    const oldFileUrls = Array.from(oldFile[data.name])?.filter(
                      (aa: any) => !(aa instanceof File)
                    );
                    if (filterFile.length > 0) {
                      obj.value = oldFileUrls.concat(filterFile);
                    } else {
                      obj.value = oldFileUrls === undefined ? [] : oldFileUrls;
                    }
                  } else {
                    obj.value = oldFile[data.name];
                  }
                } else if (iframeData.apiCall && obj.type === "iframe") {
                  obj.value = "completed";
                } else if (obj.type !== "iframe" || obj.type !== "file") {
                  obj.value = paramsData[data.name];
                }
                const userFirstName = Object.keys(obj);
                const checkFirstName = userFirstName.find((res: any) => res.includes("firstName"));
                if (checkFirstName === "firstName") {
                  localStorage.setItem("clindFirstName", obj["value"]);
                }
                return obj;
              }
            }),
          };
        } else {
          return ress;
        }
      });

      let firstNameField = sendData.flatMap(forms => forms?.fields?.filter(ress => ress?.firstName === true));
      let lastNameField = sendData.flatMap(forms => forms?.fields?.filter(ress => ress?.lastName === true));
      let candidateName = (firstNameField[0]?.value ? firstNameField[0]?.value : "") + " " + (lastNameField[0]?.value ? lastNameField[0]?.value : "");
      if (candidateName.trim() !== "") {
        let newCandidateName = localStorage.setItem("newCandidateName", candidateName);
      } else {
        let newCandidateName = localStorage.setItem("newCandidateName", "");
      }

      submitCandidateData(sendData);
    }
  }, [fileUploadValue]);

  const fileUploadApiCall = (params: any) => {
    const checkAndSplit = params?.filter(
      (ress: any) => ress?.file instanceof File
    );
    const findPDFLabel = (fileId: any, formObject: any) => {
      let fileIdString = fileId.toString();
      let fileName = fileIdString.split(".").pop();
      let subformName = fileIdString.substring(0, fileIdString.indexOf("_"));
      let subformIndex = fileIdString.substring(fileIdString.indexOf("_") + 1, fileIdString.indexOf("_") + 2);  //Numeric identifier for field set, ie., different PDF labels      
      let subformFinalIndexArrayPointer = fileIdString.substring(fileIdString.indexOf(".") + 1, fileIdString.indexOf(".") + 2);
      let subformFinalIndex: any, labelList: any, subformLocation: any;
      if (subformName.length > 0) {
        // has subforms
        subformFinalIndex = formObject.filter((f: {}) => Object.keys(f).find((e) => e === subformName));
        subformLocation = subformFinalIndex.find((e: { name: string; }) => e.name === ("subForm-" + subformIndex)); //Finds the subform under the key: name which has the string "subForm"
        //get pdf label after finding file name attached to subform
        return subformLocation.subForm?.find((o: { name: any; }) => o.name === fileName).pdfLabel;
      }
      else {
        //no subforms
        labelList = formObject.filter((f: {}) => Object.keys(f).find((e) => e === "pdfLabel"));
        return formObject.find((f: { name: any; }) => f.name === fileId).pdfLabel;
      }
    };
    if (checkAndSplit.length > 0) {
      apiIndex = 0;
      fileValue = 100 / checkAndSplit.length;
      setSaveModel(true);
      const activeFormData: any = updateFormData.filter((ress) => ress?.active);
      const obj = { ...activeFormData[0] };
      const pathParamObj: any = {};
      pathParamObj["clientId"] = sessionStorage.getItem("clientId");
      pathParamObj["domainWithHttp"] = domainWithHttp;
      const filesSubmit = async () => {
        const fData = new FormData();
        fData.append("pdfLabel", findPDFLabel(checkAndSplit[apiIndex]?.fieldId, obj?.fields));
        fData.append("formLabel", obj["label"]);
        fData.append("clientId", obj["clientId"]);
        fData.append("candidateId", obj["candidateId"]);
        fData.append("formId", obj["formId"]);
        fData.append("fieldId", checkAndSplit[apiIndex]?.fieldId);
        fData.append("files", checkAndSplit[apiIndex]?.file);
        const response: any = await apiPost(
          endPoint.createCandidateDataDocuments,
          fData,
          pathParamObj
        );

        if (handleExpiredLink(response)) {
          setSaveModel(false);
          return;
        }

        if (response.status === 200) {
          const obj: any = {};
          obj["file"] = {
            fieldId: response?.data?.data?.fieldId,
            url: response?.data?.data?.url[0],
            name: response?.data?.data?.fileName,
          };
          obj["name"] = response?.data?.data?.fileName;
          obj["newUrl"] = true;
          setUplaodFileUrl((prs: any) => [...prs, obj]);
          setFileUploadValue((prevValue) => prevValue + fileValue);
          apiIndex++;
          if (checkAndSplit.length > apiIndex) {
            filesSubmit();
          }
        } else {
          console.log();
        }
      };
      if (checkAndSplit?.length > 0) {
        filesSubmit();
      }
    } else {
      setFileUploadValue(100);
    }
    return;
  };

  const removeJsonFieldValue = (params: any) => {
    return {
      ...params,
      subForm: params.subForm.map((ress: any) => {
        return {
          ...ress,
          value: "",
        };
      }),
    };
  };

  const checkIsFormValueChanged = (initialvalue: any) => {
    const getPrsActiveIndex: any[] = updateFormData.filter(
      (ress) => (ress.active === true && (isTfnForm === 1 || isSuperForm === 1))
    );

    let activeFormIndex = getPrsActiveIndex?.[0];

    if (getPrsActiveIndex?.[0]?.["isTFNForm"] !== 1 && getPrsActiveIndex?.[0]?.["isSuperForm"] !== 1) {
      return; // It mean it's not a active tfn form.
    }
    let currentActivePage = getPrsActiveIndex[0]["index"] ? getPrsActiveIndex[0]["index"] : 0;
    const formData = formRef.current[currentActivePage];
    const checkingDataUpdate = Object.keys(formData?.initialValues).map(
      (ress) => {
        if (Array.isArray(formData.initialValues[ress])) {
          if (
            formData.initialValues[ress].length !== formData.values[ress].length
          ) {
            // setDataIsUpdated(true);
            return true;
          } else {
            let hasMismatch = false;
            formData.initialValues[ress].forEach((item: any, i: number) => {
              if (item.name !== formData.values[ress][i]?.name) {
                // setDataIsUpdated(true);
                hasMismatch = true;
              } else {
                Object.keys(item).forEach((xx) => {
                  if (
                    formData.initialValues[ress][i][xx] !==
                    formData.values[ress][i][xx]
                  ) {
                    hasMismatch = true;
                    // setDataIsUpdated(true);
                  }
                });
              }
            });
            return hasMismatch;

          }
        } else if (formData.initialValues[ress] !== formData.values[ress]) {
          if (activeFormIndex?.["isSuperForm"] === 1) {
            setIsSuperFormChanges(true);
          }

          if (activeFormIndex?.["isTFNForm"] === 1) {
            setIsTFNFormChanges(true);
          }

          return true;
        }
        return null;
      }
    );



    const trueValues = checkingDataUpdate.some(
      (element, k) => element === true
    );

    if (trueValues) {
      if (activeFormIndex?.["isSuperForm"] === 1) {
        setIsSuperFormChanges(true);
        setSuperSigningUrl("");
        setIsSuperSigned(false);
        setSuperSignedUrl("");
      }

      if (activeFormIndex?.["isTFNForm"] === 1) {
        setIsTFNFormChanges(true);
        setSigningUrl("");
        setIsSigned(false);
        setSignedUrl("");
      }

    }

  };

  const fileUploadData = async () => {
    setSveAndExitModel(false);
    const updateNewSubForm = updateFormData.map((ress, i) => {

      if ((changeParams && changeParams?.prsIndex === i) || ress.active) {
        const paramsData = formRef?.current[i]?.values;
        const getSubFormFromList1 = ress.fields.filter(
          (ress) => ress?.subForm && ress.name === "subForm-1"
        );
        const getSubFormFromList2 = ress.fields.filter(
          (ress) => ress?.subForm && ress.name === "subForm-2"
        );
        const getSubFormFromList3 = ress.fields.filter(
          (ress) => ress?.subForm && ress.name === "subForm-3"
        );
        const notGetSubFormFromList = ress.fields.filter(
          (ress) => !ress.subForm
        );
        const field: any = [];
        ress.fields.forEach((element: any) => {
          if (element.name !== "subForm-1" && element.name !== "subForm-2" && element.name !== "subForm-3") {
            const obj = { ...element };
            obj.value = "";
            field.push(element);
          } else {
            if (element.name === "subForm-1" && element.status) {
              paramsData.subForm_1.forEach((xx: any, i: number) => {
                const updatedObject = {
                  ...getSubFormFromList1[0],
                  status: i === 0 ? true : false,
                };
                field.push(removeJsonFieldValue(updatedObject));
              });
            } else if (element.name === "subForm-2" && element.status) {
              paramsData.subForm_2.forEach((xx: any, i: number) => {
                const updatedObject = {
                  ...getSubFormFromList2[0],
                  status: i === 0 ? true : false,
                };
                field.push(removeJsonFieldValue(updatedObject));
              });
            } else if (element.name === "subForm-3" && element.status) {
              paramsData.subForm_3.forEach((xx: any, i: number) => {
                const updatedObject = {
                  ...getSubFormFromList3[0],
                  status: i === 0 ? true : false,
                };
                field.push(removeJsonFieldValue(updatedObject));
              });
            }
          }
        });

        return {
          ...ress,
          fields: field,
        };
      }
      return ress;
    });
    setUpdateFormData(updateNewSubForm);
    const multiFileListConvertToSingle: any = [];
    setUplaodFileUrl([]);

    Object.keys(oldFile).forEach(async (ress) => {
      for (const fileObj of oldFile[ress]) {
        if (fileObj instanceof File) {
          multiFileListConvertToSingle.push({
            file: fileObj,
            name: fileObj.name,
            fieldId: ress,
          });
        } else {
          multiFileListConvertToSingle.push({
            file: fileObj.file,
            name: fileObj.name,
            fieldId: ress,
          });
        }
      }
    });
    if (multiFileListConvertToSingle.length > 0) {
      fileUploadApiCall(multiFileListConvertToSingle);
    } else {
      setFileUploadValue(100);
    }
    if (getFilesForDeletion?.length > 0) {
      deleteFilesFromServer();
    }
  };

  const saveModelClose = () => {
    setCountControl((prs) => {
      return {
        ...prs,
        saveModel: false,
        saveDraftTest: false,
      };
    });
  };
  const saveAndEditTime = (formIndex: any) => {
    setTimeout(() => {
      const paramsData = formRef.current[formIndex].errors;
      const errorData: any = Object.values(paramsData);
      if (errorData?.length > 0) {
        setSveAndExitModel(false);
        sessionStorage.setItem("navigateTo", (formIndex + 1).toString());
        return;
      }
    }, 1000);
    // else {
    //   // fileUploadData();

    // }


    formstatus = "draft";
  };


  const saveAndEdit = () => {
    formstatusTwo = true;
    const prsForm: any = updateFormData.filter((ress: any) => ress.active);
    if (
      candidateData.finalStep === null ||
      prsForm[0]["index"] + 1 === Number(candidateData.finalStep)
    ) {

      fileUploadData();
      formstatus = "draft";
      setCountControl((prs) => {
        return {
          ...prs,
          saveModel: false,
          fileUplaod: false,
        };
      });
      setSveAndExitModel(false);
      setSaveToExitModel(false);
    } else {
      fileUploadData();
      // document.getElementById(`submitBtn_${prsForm[0]["index"]}`)?.click();
      // // setSveAndExitModel(false);
      setCountControl((prs) => {
        return {
          ...prs,
          saveModel: false,
          fileUplaod: false,
        };
      });
    }
  };

  const removeCurrentData = () => {
    const params: any = changeParams.params;
    if (
      changeParams?.index !== null &&
      candidateData?.finalStep >= changeParams?.index
    ) {
      const modifideFormData = updateFormData.map((data: any, k) => {
        const obj = { ...data };
        obj.active = false;
        if (params?.formId === data.formId) {
          obj.active = true;
          obj.currentPage = true;
          obj.currentPageStyle = "current-page";
        } else {
          if (candidateData?.finalStep > k + 1) {
            obj.completedPage = true;
            obj.currentPageStyle = "current-page";
            obj.currentPage = false;
          } else {

            obj.completedPage = false;
            obj.currentPageStyle = "null";
            obj.currentPage = false;
          }
        }
        if (params?.index === k) {
          return {
            ...obj,
            indata: params.indata,
          };
        } else {
          return obj;
        }
      });
      setUpdateFormData(modifideFormData);
      setSveAndExitModel(false);
    }
  };
  const getCurrentPage = (params: any, i: number) => {
    const navigateTo: any = sessionStorage.getItem("navigateTo");
    if (signingUrl?.length > 0 || superSigningUrl?.length > 0) {
      toast("Please sign the document before moving to next page.", {
        type: "error",
        autoClose: 50000,
      });
      return;
    }
    setSigningUrl("");
    setSuperSigningUrl("");
    setIsTFNFormChanges(false);
    setIsSuperFormChanges(false);
    if (updateFormData.length === i) {
      setIsLastPage(true);
    } else {
      setIsLastPage(false);
    }

    // if (navigateTo !== null && navigateTo !== undefined && Number(navigateTo) === (i)) {
    //   if (params.isTFNForm === 1) {
    //     setTfnFormIndex(params.index);
    //     document.body.classList.add("tfnForm");
    //     document.getElementById("personal-details-"+tfnFormIndex)?.classList.replace("d-none", "d-flex");

    //   }else{
    //     document.body.classList.remove("tfnForm");
    //   }
    //   // return;
    // } else {
    setSveAndExitModel(false);
    setSaveToExitModel(true);
    const getPrsActiveIndex: any[] = updateFormData.filter(
      (ress) => ress.active
    );



    if (params.isTFNForm === 1) {
      setTfnFormIndex(params.index);
      document.body.classList.add("tfnForm");
      document.body.classList.remove("theme-form-id1");
      document.getElementById("personal-details-" + tfnFormIndex)?.classList.replace("d-none", "d-flex");

    } else if (params.isSuperForm === 1) {
      setSuperFormIndex(params.index);
      document.body.classList.add("theme-form-id1");
      document.body.classList.remove("tfnForm");
      document.getElementById("personal-details-" + superFormIndex)?.classList.replace("d-none", "d-flex");
    } else {
      document.body.classList.remove("tfnForm");
      document.body.classList.remove("theme-form-id1");
    }



    let currentActivePage = getPrsActiveIndex?.[0]?.["index"] ? getPrsActiveIndex[0]["index"] : 0;
    const formData = formRef.current[currentActivePage];
    changeParams = {
      params: params,
      index: i,
      prsIndexValues: formData,
      prsIndex: currentActivePage,
    };
    sessionStorage.setItem("navigateTo", i.toString());
    // sessionStorage.setItem("prs", changeParams.prsIndex);
    setDataIsUpdated(false);
    const checkingDataUpdate = Object.keys(formData?.initialValues).map(
      (ress) => {
        if (Array.isArray(formData.initialValues[ress])) {
          if (
            formData.initialValues[ress].length !== formData.values[ress].length
          ) {
            setDataIsUpdated(true);
            return true;
          } else {
            let hasMismatch = false;
            formData.initialValues[ress].forEach((item: any, i: number) => {
              if (item.name !== formData.values[ress][i]?.name) {
                setDataIsUpdated(true);
                hasMismatch = true;
              } else {
                Object.keys(item).forEach((xx) => {
                  if (
                    formData.initialValues[ress][i][xx] !==
                    formData.values[ress][i][xx]
                  ) {
                    hasMismatch = true;
                    setDataIsUpdated(true);
                  }
                });
              }
            });
            return hasMismatch;
            // }else{

            // }
          }
          // }
        } else if (formData.initialValues[ress] !== formData.values[ress]) {
          setDataIsUpdated(true);
          return true;
        }
        return null;
      }
    );

    const trueValues = checkingDataUpdate.some(
      (element, k) => element === true
    );

    let newActivePage = params?.index;

    if (newActivePage) { // added to show two form in single page when navigating via timeline

      if (updateFormData[newActivePage]) {
        if (updateFormData && updateFormData[newActivePage]) {
          updateFormData[newActivePage].active = true;
          updateFormData[i].active = false;
        }
        updateFormData[newActivePage].currentPage = true;
      }
      setUpdateFormData(updateFormData);
    }

    if (trueValues) {
      setSveAndExitModel(true);
    } else {
      removeCurrentData();
    }
    // }

  };

  const removeEditData = () => {
    navigate(0);
  };
  const checkWithFormStatus = () => {
    formstatus = "draft";


    const prsForm: any = updateFormData.filter(
      (ress: any) => ress.index === changeParams.prsIndex
    );
    if (prsForm[0]["index"] + 1 === Number(candidateData.finalStep)) {
      checkTimeline = "cheking";
      updateValudatesetFormstatus("draft");
      document.getElementById(`submitBtn_${prsForm[0]["index"]}`)?.click();
      setCountControl((prs) => {
        return {
          ...prs,
          timelineUpdate: true
        };
      });
      saveAndEditTime(prsForm[0]["index"]);
    } else {
      checkTimeline = "";
      document.getElementById(`submitBtn_${prsForm[0]["index"]}`)?.click();
      setSveAndExitModel(false);
      sessionStorage.setItem("navigateTo", (prsForm[0]["index"] + 1).toString());

    }
    formstatusTwo = true;
  };
  const modelHeader = () => {
    return (
      <>
        <Modal.Header>
          <div>File upload</div>
        </Modal.Header>
      </>
    );
  };

  const modelBody = () => {
    return (
      <>
        <Modal.Body>
          <ProgressBar
            now={Math.round(fileUploadValue)}
            animated
            label={`${Math.round(fileUploadValue)}%`}
          />
          <div className="file-name-list">
            <ul className="list-group list-group-flush">
              {uploadFileUrl.map((ress: any) => {
                return (
                  <>
                    {ress.newUrl ? (
                      <li
                        key={ress.name}
                        className="list-group-item px-0 d-flex justify-content-between align-items-start"
                      >
                        <div className="ms-2 me-auto">{ress.file.name}</div>
                        <span className="">
                          <div className="upload-file-list-name">
                            <i className="pi pi-check"></i>
                          </div>
                        </span>
                      </li>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
            </ul>
          </div>
        </Modal.Body>
      </>
    );
  };

  const closeModel = () => {
    setCountControl((prs) => {
      return {
        ...prs,
        show: false,
      };
    });
  };
  const saveModelBody = () => {
    return (
      <>
        {!countControl.saveDraftTest ? (
          <>
            <Modal.Body className="p-3">
              <div className="d-flex">
                <div>
                  <h3 className="heading-3">
                    Are you sure you want to save and exit?
                  </h3>
                  <p className="save-para mb-0">
                    You will be able to return to finish this form at any time before the due date via the unique link in your email.
                  </p>
                </div>
                <div>
                  <div>
                    <i
                      role="button"
                      onClick={() => saveModelClose()}
                      className="pi pi-times"
                    ></i>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="p-3">
              <div className="text-end">
                <Button
                  label={"No, Continue Onboarding"}
                  onClick={() => {
                    saveModelClose();
                  }}
                  clasName="btn save-close-button"
                />
                <Button
                  label={
                    <>
                      <div className="d-flex">
                        <div className="yes-save-div">
                          <i className="pi pi-check"></i>
                        </div>
                        <span className="ms-2">Yes, Save & Complete Later</span>
                      </div>
                    </>
                  }
                  onClick={() => {
                    saveAndEdit();
                  }}
                  clasName="btn btn-primary ms-3"
                />
              </div>
            </Modal.Footer>
          </>
        ) : (
          <>
            <Modal.Body className="p-3">
              <div className="d-flex  justify-content-between">
                <div>
                  <h3 className="success-text d-flex">
                    <div className="bg-round">
                      <i className="pi pi-check"></i>
                    </div>
                    <span className="ps-2">
                      Your form has been saved successfully
                    </span>
                  </h3>
                  <p className="save-para-1 mb-0">
                    You may now close this window.
                  </p>
                </div>
                <div>
                  <div>
                    <i
                      role="button"
                      onClick={() => saveModelClose()}
                      className="pi pi-times"
                    ></i>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </>
        )}
      </>
    );
  };

  const confirmMass = () => {
    return (
      <>
        <Modal.Body className="p-3">
          <div className="d-flex justify-content-between">
            <div>
              <h3 className="heading-3">
                Are you sure you want to save existing data?
              </h3>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="p-3">
          <div className="text-center w-100">
            <Button
              label={"No"}
              onClick={() => {
                removeEditData();
              }}
              clasName="btn save-close-button"
            />
            <Button
              label={
                <>
                  <div className="d-flex">
                    <div className="yes-save-div">
                      <i className="pi pi-check"></i>
                    </div>{" "}
                    <span className="ms-2">Yes</span>
                  </div>
                </>
              }
              onClick={() => checkWithFormStatus()}
              clasName="btn btn-primary ms-3"
            />
          </div>
        </Modal.Footer>
      </>
    );
  };

  const removeFile = (index: any, filename: any, name: any, formik: any, fileItem?: any) => {
    const checkFieldId = name.split(".");
    const removeFileInStore: any[] = [];
    //initial call to delete file from server
    if (fileItem?.file?.url) {
      setFilesForDeletion((files: any) => [...files, fileItem?.file?.url]);
    }
    //remove locally
    if (checkFieldId.length === 3) {
      oldFile[name]?.forEach((data: any) => {
        if (data.name !== filename) {
          removeFileInStore.push(data);
        }
      });
      oldFile[name] = removeFileInStore;
      formik?.setFieldValue(name, removeFileInStore);
    } else {
      oldFile[name]?.forEach((data: any) => {
        if (data.name !== filename) {
          removeFileInStore.push(data);
        }
      });
      // oldFile[name] = removeFileInStore;
      const updateFile = { ...oldFile };
      updateFile[name] = removeFileInStore;
      updateOldFile(updateFile);
      formik?.setFieldValue(name, removeFileInStore);
    }
  };

  const base64StringToBlob = (base64String: any) => {
    const byteCharacters = atob(base64String);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: "application/octet-stream" });
  };
  const downloadFile = async (params: any) => {
    const obj: any = {};
    const pathParamObj: any = {};
    obj["url"] = params?.file?.url;
    pathParamObj["clientId"] = sessionStorage.getItem("clientId");
    pathParamObj["domainWithHttp"] = domainWithHttp;
    const responce = await apiPost(endPoint.download, obj, pathParamObj);
    if (responce.status === 200) {
      const blob = base64StringToBlob(responce?.data?.data);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = params?.file?.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  };
  const removeFileControl = (formik: any, data: any, index: number) => {
    return (
      <>
        <ol className="document-list-parent">
          {formik.values[data.name]?.map((item: any, i: number) => {
            return (
              <>
                <li
                  key={i}
                  className="document-list mb-3 cust-document-list"
                >
                  <span className="file-name">
                    <Image src={DocIcon} />
                    {item instanceof File ? item.name : item.name}
                  </span>
                  <span role="button" className="ml-auto close-icon">
                    <i
                      onClick={() =>
                        removeFile(i, item.name, data.name, formik, item)
                      }
                      className="pi pi-times"
                    ></i>
                  </span>
                  {/* formik?.setFieldValue(data.name, removeFile(i, item.name, data.name, formik)) */}

                  {item instanceof File ? (
                    ""
                  ) : (
                    <i
                      className="pi pi-download me-3 d-none"
                      onClick={() => downloadFile(item)}
                    ></i>
                  )}
                  {formik.submitCount !== 0 &&
                    formik.errors &&
                    formik.errors[data.name] &&
                    Array.isArray(formik.errors[data.name]) ? (
                    <>
                      <span className="error-massage">
                        {
                          formik.errors[data.name]
                            ?.filter(
                              (data: any) =>
                                typeof data === "string" &&
                                data.split("_+_")[0] === item.name
                            )[0]
                            ?.split("_+_")[1]?.split("||")[0]
                        }
                      </span>
                    </>
                  ) : (
                    ""
                  )}

                </li>
              </>
            );
          })}
        </ol>
      </>
    );
  };

  useEffect(() => {
    if (iframeData.apiCall) {
      const obj: any = {};
      const pathParamObj: any = {};
      const controlEsign = updateFormData.filter((data: any) => data.active);
      obj["candidateId"] = controlEsign[0]?.candidateId;
      obj["clientId"] = controlEsign[0]?.clientId;
      obj["agreementId"] = controlEsign[0]?.fields.filter(
        (tt) => tt.type === "iframe"
      )[0]?.agreementId;
      pathParamObj["clientId"] = sessionStorage.getItem("clientId");
      pathParamObj["domainWithHttp"] = domainWithHttp;
      const sineData = async () => {
        dispatch<any>(loderControl());
        const response = await apiPost(endPoint.agreement, obj, pathParamObj);
        if (response.status === 200) {
          formstatus = "draft";
          fileUploadData();
        }
      };
      sineData();
    }
  }, [iframeData]);

  const handleIframeMessage = async (event: MessageEvent<any>) => {
    if (typeof event?.data === "string") {
      try {
        const jsonObject = JSON.parse(event?.data);
        if (jsonObject?.type === "ESIGN") {
          setIframeData((prs: any) => {
            return {
              ...prs,
              apiCall: true,
              sigcontrol: true,
            };
          });
        }
      } catch (error) {
        // Ignore non-JSON messages from iframe or other sources
        console.debug("Received non-JSON iframe message:", event?.data);
      }
    }
  };
  
  useEffect(() => {
    window.addEventListener("message", handleIframeMessage);
    return () => {
      window.removeEventListener("message", handleIframeMessage);
    };
  }, []);

  const addNewChildForm = (params: any) => {
    const obj: any = {};
    Object.keys(params).forEach((ress) => {
      obj[ress] = "";
    });
    return obj;
  };
  const removeSubFormIndex = (params: any, index: number, formName: string) => {
    const obj: any = {};
    Object.keys(params[0]).forEach((ress) => {
      const removeFileData = Object.keys(oldFile).filter(
        (data) =>
          `${formName}.${index}.${data}` === `${formName}.${index}.${ress}`
      );
      delete oldFile[`${formName}.${index}.${removeFileData}`];
      Object.keys(oldFile).forEach((ress) => {
        const sumformKey = ress?.split(".");
        if (sumformKey.length === 3 && sumformKey[0] === formName) {
          if (parseInt(sumformKey[1]) === index) {
            delete oldFile[
              sumformKey[0] + "." + sumformKey[1] + "." + sumformKey[2]
            ];
          }
        }
      });
    });
    updateOldFile(oldFile);
    return index;
  };
  const subForm_2 = (formik: any, htmlForm: any) => {
    const getChildFormJson = htmlForm.filter(
      (data: any) => data.subForm && data.name === "subForm-2"
    );
    return (
      <>
        {getChildFormJson.length > 0 &&
          formik?.values?.subForm_2?.length > 0 ? (
          <>
            <FieldArray name="subForm_2">
              {({ insert, remove, push, form }) => (
                <>
                  {formik?.values?.subForm_2?.map(
                    (item: any, subIndex: number) => {
                      return (
                        <>
                          <hr className="hrline" />

                          <div className="row cust-cont-row">
                            {getChildFormJson[0].subForm.map(
                              (setChildField: any) => {
                                return (
                                  <>
                                    <div className={setChildField?.className}>
                                      <div className="row">
                                        <div
                                          className={`${setChildField?.lableClass}`}
                                        >
                                          <Label
                                            name={setChildField?.label}
                                            className="form-label"
                                            label={setChildField?.label}
                                            subLabel={setChildField?.subLabel}
                                            required={setChildField?.required}
                                          />
                                        </div>
                                        <small className="form-description">
                                          {setChildField?.description}
                                        </small>

                                        <div
                                          className={`${setChildField?.inputClass}`}
                                        >
                                          {setChildField?.type === "date" ? (
                                            <>
                                              <FormikControl
                                                control="date"
                                                type={setChildField?.type}
                                                name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                                dateFormat={
                                                  setChildField?.dateFormat
                                                }
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "file" ? (
                                            <>
                                              <FormikControl
                                                control="file"
                                                name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                              />
                                              <>
                                                <div className="col-12">
                                                  {formik?.values?.subForm_2[
                                                    subIndex
                                                  ][setChildField.name]
                                                    ?.length > 0 ? (
                                                    <>
                                                      <ol className="document-list-parent">
                                                        {Array.isArray(
                                                          formik.values
                                                            ?.subForm_2[
                                                          subIndex
                                                          ][setChildField?.name]
                                                        )
                                                          ? formik.values?.subForm_2[
                                                            subIndex
                                                          ][
                                                            setChildField
                                                              ?.name
                                                          ].map(
                                                            (
                                                              ress: any,
                                                              i: number
                                                            ) => {
                                                              return (
                                                                <>
                                                                  {/* <div className={item.UrlClass}> */}
                                                                  <li
                                                                    key={i}
                                                                    className="document-list mb-3 cust-document-list"
                                                                  >
                                                                    <span className="file-name">
                                                                      <Image src={DocIcon} />
                                                                      {ress instanceof
                                                                        File
                                                                        ? ress.name
                                                                        : ress
                                                                          ?.file
                                                                          ?.name}
                                                                    </span>

                                                                    <span role="button" className="ml-auto close-icon">
                                                                      <i
                                                                        className="pi pi-times"
                                                                        onClick={() =>
                                                                          removeFile(
                                                                            i,
                                                                            ress.name,
                                                                            `subForm_2.${subIndex}.${setChildField.name}`,
                                                                            formik,
                                                                            ress
                                                                          )
                                                                        }
                                                                      ></i>
                                                                    </span>

                                                                    {ress instanceof
                                                                      File ? (
                                                                      ""
                                                                    ) : (
                                                                      <i
                                                                        onClick={() =>
                                                                          downloadFile(
                                                                            ress
                                                                          )
                                                                        }
                                                                        className="pi pi-download me-3 d-none"
                                                                      ></i>
                                                                    )}
                                                                    {/* {formik.submitCount !==
                                                                        0 &&
                                                                        formik
                                                                          .errors
                                                                          ?.subForm_2 &&
                                                                        formik
                                                                          .errors
                                                                          ?.subForm_2[
                                                                        subIndex
                                                                        ] &&
                                                                        Array.isArray(
                                                                          formik
                                                                            .errors
                                                                            ?.subForm_2[
                                                                          subIndex
                                                                          ][
                                                                          setChildField
                                                                            ?.name
                                                                          ]
                                                                        ) ? (
                                                                        <>
                                                                          {formik.errors?.subForm_2[
                                                                            subIndex
                                                                          ][
                                                                            setChildField
                                                                              ?.name
                                                                          ]?.filter(
                                                                            (
                                                                              data: string
                                                                            ) =>
                                                                              data ===
                                                                              (ress instanceof
                                                                                File
                                                                                ? ress.name
                                                                                : ress
                                                                                  ?.file
                                                                                  ?.name)
                                                                          )
                                                                            ?.length ===
                                                                            1 ? (
                                                                            <span className="error-massage me-5">
                                                                              File
                                                                              type
                                                                              is
                                                                              not
                                                                              allowed
                                                                            </span>
                                                                          ) : (
                                                                            ""
                                                                          )}
                                                                        </>
                                                                      ) : (
                                                                        ""
                                                                      )} */}
                                                                    <span className="error-massage">
                                                                      {
                                                                        formik?.submitCount !== 0 &&
                                                                        formik?.errors &&
                                                                        formik?.errors?.subForm_2 &&
                                                                        Array.isArray(formik?.errors?.subForm_2) &&  // Check if subForm_1 is an array
                                                                        formik?.errors?.subForm_2.length > 0 &&
                                                                        formik?.errors?.subForm_2[subIndex] &&
                                                                        formik?.errors?.subForm_2[subIndex][setChildField?.name] &&
                                                                        Array.isArray(formik?.errors?.subForm_2[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                        formik?.errors?.subForm_2[subIndex][setChildField?.name]?.length > 0 &&
                                                                        Array.isArray(formik?.errors?.subForm_2[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                        formik?.errors?.subForm_2[subIndex][setChildField?.name]?.filter((data: any) => typeof data === "string" && data.split("_+_")[0] === ress.name)?.[0]?.split("_+_")[1]?.split("||")?.[0]
                                                                      }
                                                                    </span>

                                                                  </li>
                                                                </>
                                                              );
                                                            }
                                                          )
                                                          : null}
                                                      </ol>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              </>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField.type ===
                                            "checkbox-group" ||
                                            setChildField.type === "checkbox" ? (
                                            <>
                                              <FormikControl
                                                control="checkbox"
                                                name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type ===
                                            "radio-group" ? (
                                            <>
                                              <FormikControl
                                                control="radio"
                                                name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "html" ? (
                                            <>
                                              <div
                                                className="com-html-text"
                                                dangerouslySetInnerHTML={{
                                                  __html: setChildField?.value,
                                                }}
                                              ></div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "select" ? (
                                            <>
                                              <FormikControl
                                                control="select"
                                                type={setChildField?.type}
                                                name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                className={"form-select"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "multiSelect" ? (
                                            <>
                                              <FormikControl
                                                control="multiSelect"
                                                type={setChildField?.type}
                                                name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                className={"form-select"}
                                                allData={setChildField}
                                                multi={true}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}

                                          {setChildField.type === "text" ||
                                            setChildField.type === "number" || setChildField.type === "split-input" ? (
                                            <>
                                              <FormikControl
                                                control="input"
                                                type={setChildField?.type}
                                                name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField.type === "textarea" ? (
                                            <>
                                              <FormikControl
                                                control="textarea"
                                                type={setChildField?.type}
                                                name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                        {formik?.values?.subForm_2?.length >
                                          1 ? (
                                          <>
                                            {setChildField?.addButton ? (
                                              <div
                                                className="btn-add-remove-section"
                                              >
                                                <Button
                                                  clasName="btn btn-secondary add-subform-button cust-remove-button"
                                                  type="button"
                                                  onClick={() =>
                                                    remove(
                                                      removeSubFormIndex(
                                                        formik?.initialValues
                                                          ?.subForm_2,
                                                        subIndex,
                                                        "subForm_2"
                                                      )
                                                    )
                                                  }
                                                  label={
                                                    <>
                                                      <div className="d-flex align-items-center">
                                                        <Image
                                                          src={Bin}
                                                          clasName="me-2"
                                                        />{" "}
                                                        <div>
                                                          {
                                                            getChildFormJson[0]
                                                              ?.removeButtonLabel
                                                          }
                                                        </div>
                                                      </div>
                                                    </>
                                                  }
                                                />
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </>
                                );
                              }
                            )}
                          </div>
                        </>
                      );
                    }
                  )}



                  {getChildFormJson[0]?.AddButtonCount > formik?.values?.subForm_2?.length ?

                    <div className="btn-add-remove-section">
                      <Button
                        position="left"
                        icon="pi pi-plus add-subform-icon"
                        label={getChildFormJson[0]?.AddButtonLabel}
                        type="button"
                        onClick={() =>
                          push(
                            addNewChildForm(formik?.initialValues?.subForm_2[0])
                          )
                        }
                        clasName="btn add-subform-button"
                      />
                    </div>
                    :
                    ""
                  }

                </>
              )}
            </FieldArray>
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  const subForm_1 = (formik: any, htmlForm: any) => {
    const getChildFormJson = htmlForm.filter(
      (data: any) => data.subForm && data.name === "subForm-1"
    );
    return (
      <>
        {getChildFormJson.length > 0 &&
          formik?.values?.subForm_1?.length > 0 ? (
          <>
            <FieldArray name="subForm_1">
              {({ insert, remove, push, form }) => (
                <>
                  {formik?.values?.subForm_1?.map(
                    (item: any, subIndex: number) => {
                      return (
                        <>
                          <hr className="hrline" />
                          <div className="row cust-cont-row">
                            {getChildFormJson[0].subForm.map(
                              (setChildField: any) => {
                                return (
                                  <>
                                  { checkParentMatch(setChildField, formik.values?.subForm_1[subIndex]) ? (
                                    <div className={setChildField?.className}>
                                      <div className="row">
                                        <div
                                          className={`${setChildField?.lableClass}`}
                                        >
                                          <Label
                                            name={setChildField?.label}
                                            className={"form-label"}
                                            label={setChildField?.label}
                                            subLabel={setChildField?.subLabel}
                                            required={setChildField?.required}
                                          />
                                        </div>
                                        <small className="form-description">
                                          {setChildField?.description}
                                        </small>
                                        <div
                                          className={`${setChildField?.inputClass}`}
                                        >
                                          {setChildField?.type === "date" ? (
                                            <>
                                              {/* <Image src={DataIcon} /> */}
                                              <FormikControl
                                                control="date"
                                                type={setChildField?.type}
                                                name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                                dateFormat={
                                                  setChildField?.dateFormat
                                                }
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "file" ? (
                                            <>
                                              <FormikControl
                                                control="file"
                                                name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                              />
                                              <>
                                                <div className="col-12">
                                                  {formik?.values?.subForm_1[
                                                    subIndex
                                                  ][setChildField.name]
                                                    ?.length > 0 ? (
                                                    <>
                                                      <ol className="document-list-parent">
                                                        {Array.isArray(
                                                          formik.values
                                                            ?.subForm_1[
                                                          subIndex
                                                          ][setChildField?.name]
                                                        )
                                                          ? formik.values?.subForm_1[
                                                            subIndex
                                                          ][
                                                            setChildField
                                                              ?.name
                                                          ].map(
                                                            (
                                                              ress: any,
                                                              i: number
                                                            ) => {


                                                              return (
                                                                <>
                                                                  {/* <div className={item.UrlClass}> */}
                                                                  <li
                                                                    key={i}
                                                                    className="document-list mb-3 cust-document-list"
                                                                  >
                                                                    <span className="file-name">
                                                                      <Image src={DocIcon} />
                                                                      {ress instanceof
                                                                        File
                                                                        ? ress.name
                                                                        : ress
                                                                          ?.file
                                                                          ?.name}
                                                                    </span>
                                                                    <span role="button" className="ml-auto close-icon">
                                                                      <i
                                                                        className="pi pi-times"
                                                                        onClick={() =>
                                                                          removeFile(
                                                                            i,
                                                                            ress.name,
                                                                            `subForm_1.${subIndex}.${setChildField.name}`,
                                                                            formik,
                                                                            ress
                                                                          )
                                                                        }
                                                                      ></i>
                                                                    </span>

                                                                    {ress instanceof
                                                                      File ? (
                                                                      ""
                                                                    ) : (
                                                                      <i
                                                                        onClick={() =>
                                                                          downloadFile(
                                                                            ress
                                                                          )
                                                                        }
                                                                        className="pi pi-download me-3 d-none"
                                                                      ></i>
                                                                    )}
                                                                    <span className="error-massage">
                                                                      {
                                                                        formik?.submitCount !== 0 &&
                                                                        formik?.errors &&
                                                                        formik?.errors?.subForm_1 &&
                                                                        Array.isArray(formik?.errors?.subForm_1) &&  // Check if subForm_1 is an array
                                                                        formik?.errors?.subForm_1.length > 0 &&
                                                                        formik?.errors?.subForm_1[subIndex] &&
                                                                        formik?.errors?.subForm_1[subIndex][setChildField?.name] &&
                                                                        Array.isArray(formik?.errors?.subForm_1[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                        formik?.errors?.subForm_1[subIndex][setChildField?.name]?.length > 0 &&
                                                                        Array.isArray(formik?.errors?.subForm_1[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                        formik?.errors?.subForm_1[subIndex][setChildField?.name]?.filter((data: any) => typeof data === "string" && data.split("_+_")[0] === ress.name)?.[0]?.split("_+_")[1]?.split("||")?.[0]


                                                                      }

                                                                      {/* {
                                                                        // formik.submitCount !==
                                                                        //   0 &&
                                                                        formik
                                                                          .errors
                                                                          ?.subForm_1 &&
                                                                          formik
                                                                            .errors
                                                                            ?.subForm_1[
                                                                          subIndex
                                                                          ] &&
                                                                          Array.isArray(
                                                                            formik
                                                                              .errors
                                                                              ?.subForm_1[
                                                                            subIndex
                                                                            ][
                                                                            setChildField
                                                                              ?.name
                                                                            ]
                                                                          ) ? (
                                                                          <>
                                                                            {formik.errors?.subForm_1[
                                                                              subIndex
                                                                            ][
                                                                              setChildField
                                                                                ?.name
                                                                            ]?.filter(
                                                                              (
                                                                                data: string
                                                                              ) =>
                                                                                data ===
                                                                                (ress instanceof
                                                                                  File
                                                                                  ? ress.name
                                                                                  : ress
                                                                                    ?.file
                                                                                    ?.name)
                                                                            )
                                                                              ?.length ===
                                                                              1 ? (
                                                                              <span className="error-massage me-5">
                                                                                File
                                                                                type
                                                                                is
                                                                                not
                                                                                allowed
                                                                              </span>
                                                                            ) : (
                                                                              ""
                                                                            )}
                                                                          </>
                                                                        ) : (
                                                                          ""
                                                                        )
                                                                      } */}

                                                                    </span>

                                                                    {/* <span>{formik?.error?.subForm_1}</span> */}
                                                                  </li>
                                                                  {/* </div> */}
                                                                </>
                                                              );
                                                            }
                                                          )
                                                          : null}
                                                      </ol>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              </>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField.type ===
                                            "checkbox-group" ||
                                            setChildField.type === "checkbox" ? (
                                            <>
                                              <FormikControl
                                                control="checkbox"
                                                name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type ===
                                            "radio-group" ? (
                                            <>
                                              <FormikControl
                                                control="radio"
                                                name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "html" ? (
                                            <>
                                              <div
                                                className="com-html-text"
                                                dangerouslySetInnerHTML={{
                                                  __html: setChildField?.value,
                                                }}
                                              ></div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "select" ? (
                                            <>
                                              <FormikControl
                                                control="select"
                                                type={setChildField?.type}
                                                name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                className={"form-select"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "multiSelect" ? (
                                            <>
                                              <FormikControl
                                                control="multiSelect"
                                                type={setChildField?.type}
                                                name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                className={"form-select"}
                                                allData={setChildField}
                                                multi={true}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}

                                          {setChildField.type === "text" ||
                                            setChildField.type === "number" || setChildField.type === "split-input" ? (
                                            <>
                                              <FormikControl
                                                control="input"
                                                type={setChildField?.type}
                                                name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField.type === "textarea" ? (
                                            <>
                                              <FormikControl
                                                control="textarea"
                                                type={setChildField?.type}
                                                name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                        {formik?.values?.subForm_1?.length >
                                          1 ? (
                                          <>
                                            {setChildField?.addButton ? (
                                              <div
                                                className="btn-add-remove-section"
                                              >
                                                <Button
                                                  clasName="btn add-subform-button cust-remove-button"
                                                  type="button"
                                                  onClick={() =>
                                                    remove(
                                                      removeSubFormIndex(
                                                        formik?.initialValues
                                                          ?.subForm_1,
                                                        subIndex,
                                                        "subForm_1"
                                                      )
                                                    )
                                                  }
                                                  label={
                                                    <>
                                                      <div className="d-flex align-items-center">
                                                        <Image
                                                          src={Bin}
                                                          clasName="me-2"
                                                        />{" "}
                                                        <div>
                                                          {
                                                            getChildFormJson[0]
                                                              ?.removeButtonLabel
                                                          }
                                                        </div>
                                                      </div>
                                                    </>
                                                  }
                                                />
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    "" )}
                                  </>
                                );
                              }
                            )}
                            {/* <div className="d-none">
                                <div className="text-center my-2">
                                    <Button id="subForm-1-addbutton" position="left" icon="pi pi-plus add-subform-icon" label={getChildFormJson[0]?.AddButtonLabel} type="button" onClick={() => push(addNewChildForm(formik?.initialValues?.subForm_1[0]))} clasName="btn btn-primary " />
                                </div>
                            </div> */}
                          </div>
                        </>
                      );
                    }
                  )}
                  {getChildFormJson[0]?.AddButtonCount > formik?.values?.subForm_1?.length ?
                    <div className="btn-add-remove-section">
                      <Button
                        id="subForm-1-addbutton"
                        position="left"
                        icon="pi pi-plus add-subform-icon"
                        label={getChildFormJson[0]?.AddButtonLabel}
                        type="button"
                        onClick={() =>
                          push(
                            addNewChildForm(formik?.initialValues?.subForm_1[0])
                          )
                        }
                        clasName="btn add-subform-button "
                      />
                    </div>
                    :
                    ""
                  }
                </>
              )}
            </FieldArray>
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  const subForm_3 = (formik: any, htmlForm: any) => {
    const getChildFormJson = htmlForm.filter(
      (data: any) => data.subForm && data.name === "subForm-3"
    );

    return (
      <>
        {getChildFormJson.length > 0 &&
          formik?.values?.subForm_3?.length > 0 ? (
          <>
            <FieldArray name="subForm_3">
              {({ insert, remove, push, form }) => (
                <>
                  {formik?.values?.subForm_3?.map(
                    (item: any, subIndex: number) => {
                      return (
                        <>
                          <hr className="hrline" />
                          <div className="row cust-cont-row">
                            {getChildFormJson[0].subForm.map(
                              (setChildField: any) => {
                                return (
                                  <>
                                    <div className={setChildField?.className}>
                                      <div className="row">
                                        <div
                                          className={`${setChildField?.lableClass}`}
                                        >
                                          <Label
                                            name={setChildField?.label}
                                            className={"form-label"}
                                            label={setChildField?.label}
                                            subLabel={setChildField?.subLabel}
                                            required={setChildField?.required}
                                          />
                                        </div>
                                        <small className="form-description">
                                          {setChildField?.description}
                                        </small>
                                        <div
                                          className={`${setChildField?.inputClass}`}
                                        >
                                          {setChildField?.type === "date" ? (
                                            <>
                                              {/* <Image src={DataIcon} /> */}
                                              <FormikControl
                                                control="date"
                                                type={setChildField?.type}
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                                dateFormat={
                                                  setChildField?.dateFormat
                                                }
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "file" ? (
                                            <>
                                              <FormikControl
                                                control="file"
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                              />
                                              <>
                                                <div className="col-12">
                                                  {formik?.values?.subForm_3[
                                                    subIndex
                                                  ][setChildField.name]
                                                    ?.length > 0 ? (
                                                    <>
                                                      <ol className="document-list-parent">
                                                        {Array.isArray(
                                                          formik.values
                                                            ?.subForm_3[
                                                          subIndex
                                                          ][setChildField?.name]
                                                        )
                                                          ? formik.values?.subForm_3[
                                                            subIndex
                                                          ][
                                                            setChildField
                                                              ?.name
                                                          ].map(
                                                            (
                                                              ress: any,
                                                              i: number
                                                            ) => {


                                                              return (
                                                                <>
                                                                  {/* <div className={item.UrlClass}> */}
                                                                  <li
                                                                    key={i}
                                                                    className="document-list mb-3 cust-document-list"
                                                                  >
                                                                    <span className="file-name">
                                                                      <Image src={DocIcon} />
                                                                      {ress instanceof
                                                                        File
                                                                        ? ress.name
                                                                        : ress
                                                                          ?.file
                                                                          ?.name}
                                                                    </span>
                                                                    <span role="button" className="ml-auto close-icon">
                                                                      <i
                                                                        className="pi pi-times"
                                                                        onClick={() =>
                                                                          removeFile(
                                                                            i,
                                                                            ress.name,
                                                                            `subForm_3.${subIndex}.${setChildField.name}`,
                                                                            formik,
                                                                            ress
                                                                          )
                                                                        }
                                                                      ></i>
                                                                    </span>

                                                                    {ress instanceof
                                                                      File ? (
                                                                      ""
                                                                    ) : (
                                                                      <i
                                                                        onClick={() =>
                                                                          downloadFile(
                                                                            ress
                                                                          )
                                                                        }
                                                                        className="pi pi-download me-3 d-none"
                                                                      ></i>
                                                                    )}
                                                                    <span className="error-massage">
                                                                      {
                                                                        formik?.submitCount !== 0 &&
                                                                        formik?.errors &&
                                                                        formik?.errors?.subForm_3 &&
                                                                        Array.isArray(formik?.errors?.subForm_3) &&  // Check if subForm_1 is an array
                                                                        formik?.errors?.subForm_3.length > 0 &&
                                                                        formik?.errors?.subForm_3[subIndex] &&
                                                                        formik?.errors?.subForm_3[subIndex][setChildField?.name] &&
                                                                        Array.isArray(formik?.errors?.subForm_3[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                        formik?.errors?.subForm_3[subIndex][setChildField?.name]?.length > 0 &&
                                                                        Array.isArray(formik?.errors?.subForm_3[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                        formik?.errors?.subForm_3[subIndex][setChildField?.name]?.filter((data: any) => typeof data === "string" && data.split("_+_")[0] === ress.name)?.[0]?.split("_+_")[1]?.split("||")?.[0]


                                                                      }

                                                                    </span>


                                                                  </li>

                                                                </>
                                                              );
                                                            }
                                                          )
                                                          : null}
                                                      </ol>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              </>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField.type ===
                                            "checkbox-group" ||
                                            setChildField.type === "checkbox" ? (
                                            <>
                                              <FormikControl
                                                control="checkbox"
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type ===
                                            "radio-group" ? (
                                            <>
                                              <FormikControl
                                                control="radio"
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "html" ? (
                                            <>
                                              <div
                                                className="com-html-text"
                                                dangerouslySetInnerHTML={{
                                                  __html: setChildField?.value,
                                                }}
                                              ></div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "select" ? (
                                            <>
                                              <FormikControl
                                                control="select"
                                                type={setChildField?.type}
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-select"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "multiSelect" ? (
                                            <>
                                              <FormikControl
                                                control="multiSelect"
                                                type={setChildField?.type}
                                                name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                className={"form-select"}
                                                allData={setChildField}
                                                multi={true}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField.type === "text" ||
                                            setChildField.type === "number" || setChildField.type === "split-input" ? (
                                            <>
                                              <FormikControl
                                                control="input"
                                                type={setChildField?.type}
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField.type === "textarea" ? (
                                            <>
                                              <FormikControl
                                                control="textarea"
                                                type={setChildField?.type}
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                        {formik?.values?.subForm_3?.length >
                                          1 ? (
                                          <>
                                            {setChildField?.addButton ? (
                                              <div
                                                className="btn-add-remove-section"
                                              >
                                                <Button
                                                  clasName="btn add-subform-button cust-remove-button"
                                                  type="button"
                                                  onClick={() =>
                                                    remove(
                                                      removeSubFormIndex(
                                                        formik?.initialValues
                                                          ?.subForm_3,
                                                        subIndex,
                                                        "subForm_3"
                                                      )
                                                    )
                                                  }
                                                  label={
                                                    <>
                                                      <div className="d-flex align-items-center">
                                                        <Image
                                                          src={Bin}
                                                          clasName="me-2"
                                                        />{" "}
                                                        <div>
                                                          {
                                                            getChildFormJson[0]
                                                              ?.removeButtonLabel
                                                          }
                                                        </div>
                                                      </div>
                                                    </>
                                                  }
                                                />
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </>
                                );
                              }
                            )}
                          </div>
                        </>
                      );
                    }
                  )}
                  {getChildFormJson[0]?.AddButtonCount > formik?.values?.subForm_3?.length ?
                    <div className="btn-add-remove-section">
                      <Button
                        id="subForm-3-addbutton"
                        position="left"
                        icon="pi pi-plus add-subform-icon"
                        label={getChildFormJson[0]?.AddButtonLabel}
                        type="button"
                        onClick={() =>
                          push(
                            addNewChildForm(formik?.initialValues?.subForm_3[0])
                          )
                        }
                        clasName="btn add-subform-button "
                      />
                    </div>
                    :
                    ""
                  }
                </>
              )}
            </FieldArray>
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  const inputTypeFile = (formik: any, data: any, i: number) => {
    return (
      <>
        <>
          <>
            <FormikControl
              control="file"
              name={data.name}
              className={"form-control"}
              option={data.values}
              allData={data}
              value={formik.values[data.name]}
              formikData={formik}
            />
            <>
              {formik.values[data.name]?.length > 0 ? (
                <>
                  <div className={"col-12"}>
                    {removeFileControl(formik, data, i)}
                  </div>
                </>
              ) : (
                ""
              )}
            </>
          </>
        </>
      </>
    );
  };
  const errorControl = (data: any, formik: any) => {
    if (data?.name && formik?.values[data?.name]?.length > 0) {
      formik.setFieldValue(data?.name, []);
      oldFile[data.name] = [];
    }

    return "";
  };

  useEffect(() => {
    if (updateFormData?.length > 0) {
      const currentIndex: any = updateFormData.filter((ress) => ress?.currentPage);
      setTimeout(() => {
        sliderRef?.current?.slickGoTo(currentIndex[0]?.index);
      }, 800);


    }


  }, [updateFormData]);
  const parseErrors = (errDetails: any) => {
    return Object.values(errDetails);
  };

  const ErrorSummary = (props: any) => {
    const { errors } = props;
    let errorMap: any = [];
    let allErrors: any = [];
    if (Object.keys(errors).length > 0) {
      errorMap = parseErrors(errors);
    }
    return (
      <>
        {(errorMap.length > 0) &&
          <div className="error-summary card custom-card custom-card-new p-3">
            <h2 className="error-message">There were some errors in your form, please fix them to proceed with the onboarding process</h2>
            <ul>
              {
                errorMap.map((err: any) => {
                  if (!allErrors.includes(err)) {
                    allErrors.push(err);

                    let updatedErrorMsg = "";
                    if (Array.isArray(err) && typeof err[0] === "string" && JSON.stringify(err?.[0]).includes("_+_")) {
                      updatedErrorMsg = err?.[0]?.split("_+_")?.[1];
                    }
                    if (Array.isArray(err) && typeof err[0] === "string" && updatedErrorMsg?.includes("||")) {
                      const splitErrorMsg = updatedErrorMsg?.split("||");
                      updatedErrorMsg = splitErrorMsg?.[1] + " " + splitErrorMsg?.[0];
                    }
                    updatedErrorMsg = updatedErrorMsg?.replace(/"/g, "");
                    return (
                      <>
                        {typeof err === "string" ? (
                          <li className="error-message" key={err}>{`${err}`}</li>
                        ) :
                          (
                            // <li className="error-message" key={err}>Make sure all required documents are uploaded</li>
                            Array.isArray(err) && typeof err[0] === "string" && err[0]?.includes("_+_") ? (
                              <li className="error-message">{`${updatedErrorMsg}`}</li>
                            ) : (

                              <li className="error-message">Make sure to fill all the above required fields and submit the necessary documents.</li>

                            )
                          )
                        }
                      </>
                    );
                  }
                  return null;
                })
              }
            </ul>
          </div>
        }
      </>
    );
  };

  if (expiredLinkMessage) {
    return (
      <>
        <div>
          <Loader loading={loader} />
        </div>
        <div className="container">
          <div className="row justify-content-center align-item-center">
            <div className="col-md-7 col-lg-6">
              <div className="mt-5 pt-4">
                <div className="alert alert-danger text-center" role="alert">
                  <p className="mb-2">{expiredLinkMessage || "This link has been expired. Please contact administrator."}</p>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  return (
    <>
      <div>
        <Loader loading={loader} />
      </div>
      <div
        className="container-fluid pt-3 "
        ref={ref}
        style={{ backgroundColor: "#FFFF", overflow: "hidden" }}
      >
        {screenShort.active ? (
          <>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 ">
                <div>
                  <p className="page-heading">{candidateData?.pageTitle ? candidateData?.pageTitle : "Onboarding"}</p>
                  <div className="d-flex onboarding-btn-top-wrapper">
                    <Button
                      onClick={() => {

                        // bell 
                        // formstatus = "draft";
                        checkTimeline = "";
                        updateValudatesetFormstatus("draft");
                        const prsForm: any = updateFormData.filter((ress: any) => ress.active);
                        document.getElementById(`submitBtn_${prsForm[0]["index"]}`)?.click();

                        // setCountControl((prs) => {
                        //   return {
                        //     ...prs,
                        //     saveModel: true,
                        //     saveDraftTest: false,
                        //   };
                        // })
                      }
                      }
                      icon="pi pi-clock"
                      position="left"
                      label={candidateData?.draftButtonText ? candidateData?.draftButtonText : "Save & Exit"}
                      clasName="btn btn-primary btn-top-head"
                    />
                    <div className="d-block ps-3">
                      <div className="completion-progress">
                        <div
                          className="barbg"
                          style={{ width: candidateData?.completionPercentage }}
                        ></div>
                      </div>
                      <div className="completion pt-1">
                        Completion:{" "}
                        <span className="fw-bold">
                          {candidateData?.completionPercentage}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8 d-flex 
              justify-content-xl-end ">
                <div className="compliance-timeline compliance-timeline-new">
                  <div key={getOrientationChange.timeStamp} className={`slick-main-parent ${updateFormData?.length >= getScreenWidth.showCount ? "remove-start-line" : ""}`}>
                    <Slider {...settings} ref={sliderRef}>
                      {updateFormData?.map((ress: any, i: number) => {
                        return (
                          <>
                            <div
                              role={
                                Number(candidateData?.finalStep) >= i + 1
                                  ? "button"
                                  : "none"
                              }
                              onClick={() =>
                                candidateData?.finalStep !== null &&
                                  Number(candidateData?.finalStep) >= i + 1
                                  ? getCurrentPage(ress, i + 1)
                                  : ""
                              }
                              className={`slick-cont ${updateFormData?.length === 1 ? "remove-all-index-line" : ""} ${i === 0 ? "first-list" : ""} ${i + 1 === updateFormData?.length ? "last-index" : ""}
                               ${ress?.completedPage && ress.currentPage
                                  ? "slick-cont-dot-active slick-cont-line-active"
                                  : ""
                                }
                                  ${ress?.completedPage &&
                                  !ress?.currentPage
                                  ? "slick-cont slick-cont-dot-active slick-cont-line-active slick-cont-completed"
                                  : ""
                                }
                                  ${ress?.currentPage
                                  ? "completed slick-cont-dot-active slick-cont-half-line-active"
                                  : ""
                                }
                                ${candidateData?.finalStep >= (i + 1) ? " slick-cont-half-line-active" : ""}

                             

                                ${slickStyleUpdate.currentPage === i ? "first-list" : slickStyleUpdate?.nextIndex === i ? "last-index" : "000"}
                               
                                
                                `}
                            >

                              <div className="slick-cont-inner">
                                <h3>{ress.label}</h3>
                              </div>
                            </div >
                          </>
                        );
                      })}
                    </Slider>
                  </div>
                </div>
                <br />
              </div>
            </div>
            <br />
          </>
        ) : (
          ""
        )}

        <div>
          <div className="row">
            <div className="container-1000">
              {updateFormData.length > 0 ? (
                // Main title of form
                <p className="box-grey-btn main-heading-new">
                  {updateFormData?.filter((y) => y.active)[0]?.label}
                </p>
              ) : (
                ""
              )}
              <div>
                {updateFormData.map((ress: any, index: number) => {
                  return (
                    <>
                      {/* {ress.active ? */}
                      <div
                        key={ress?.formId}
                        className={ress.active ? "d-block" : "d-none"}
                      >
                        <Formik
                          initialValues={ress.indata}
                          // validationSchema={validateSchema}
                          enableReinitialize
                          innerRef={(el) => (formRef.current[index] = el)}
                          validateOnBlur={false}
                          onSubmit={(values) => {

                            checkTimeline = "";
                            if (valudatesetformstatus === "draft") {
                              checkIsFormValueChanged(ress);
                              if (countControl?.timelineUpdate) {
                                saveAndEdit();
                              } else {
                                setCountControl((prs) => {
                                  return {
                                    ...prs,
                                    saveModel: true,
                                    saveDraftTest: false,
                                  };
                                });
                              }

                            } else {
                              setCountControl((prs) => {
                                return {
                                  ...prs,
                                  timelineUpdate: false
                                };
                              });
                              formstatus = "";
                              formstatusTwo = false;
                              checkIsFormValueChanged(ress);
                              fileUploadData();

                            }

                          }}
                        >
                          {(formik) => (
                            (
                              // Form start
                              <Form>
                                <div className="row cust-cont-row personal-details" id={`${"personal-details"}-${index}`}>
                                  {ress.fields &&
                                    ress.fields.map((data: any, i: number) => {
                                      return (
                                        <>
                                          {data.type === "iframe" ? (
                                            <div className="mb-2">
                                              {!data.value ? (
                                                <>
                                                  <Iframe url={data.iframe_url} />
                                                  <div>
                                                    <FormikControl
                                                      control="input"
                                                      type={data.type}
                                                      name={data.name}
                                                      className={
                                                        "form-control d-none "
                                                      }
                                                      allData={data}
                                                      formstatus={formstatus}
                                                    />
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  <div
                                                    className="alert alert-primary"
                                                    role="alert"
                                                  >
                                                    {data.successMessage}
                                                  </div>
                                                </>
                                              )}

                                            </div>

                                          ) : (
                                            ""
                                          )}

                                          {data.type !== "iframe" ? (

                                            <>
                                      {/* //         {(data.parentValue === formik?.values[data.parentName] || data?.parentValues && data?.parentValues?.includes(formik?.values[data.parentName])) ? ( */}
                                            { checkParentMatch(data, formik.values) ? (

                                                <div
                                                  key={data.name}
                                                  className={`${data.className} ${data?.parentWrapperClass} child`}
                                                >
                                                  <div className={`mb-${data?.firstIndexMargin ? data?.firstIndexMargin : 20} first-index`}>
                                                    <div className={`row mb-0 g-1 align-items-center form-group-new ${data?.divWrapperClass}`}>
                                                      {/* ${data.label ? "" : "d-none"} */}
                                                      {data.name !==
                                                        "subForm-1" &&
                                                        data.name !==
                                                        "subForm-2" && data.name !== "subForm-3" ? (
                                                        <div
                                                          className={`${data.lableClass}`}
                                                        >
                                                          <Label
                                                            name={data?.label?.length > 0 ? data.label : ""}
                                                            className={(data.type === "html") ? "heading-md mb-1" : ""} //
                                                            label={data?.label?.length > 0 ? data.label : ""}
                                                            subLabel={
                                                              data.subLabel
                                                            }
                                                            required={
                                                              data.required
                                                            }
                                                          />

                                                          {data?.subText ? (
                                                            <div className="sub-text">
                                                              {data.subText}
                                                            </div>
                                                          ) : (
                                                            ""
                                                          )}


                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}
                                                      {data.description ? (
                                                        <small className="form-description">
                                                          {data.description}
                                                        </small>
                                                      ) : (
                                                        ""
                                                      )}

                                                      <div
                                                        className={
                                                          data.inputClass
                                                        }
                                                      >
                                                        {data.type === "html" && !data?.isHtmlLabel ? (
                                                          <>
                                                            <div
                                                              className="com-html-text"
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  data.value,
                                                              }}
                                                            ></div>
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}

                                                        {data.type === "html" && data?.isHtmlLabel ? (
                                                          <>
                                                            <div
                                                              className="com-html-text"
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  data.htmlLabel,
                                                              }}
                                                            ></div>
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}

                                                        {data?.type === "image" ? (
                                                          <>
                                                            <img src={data?.imageUrl} className="img-fluid" alt={data?.name} />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type ===
                                                          "select" ? (
                                                          <>
                                                            <FormikControl
                                                              control="select"
                                                              type={data.type}
                                                              name={data.name}
                                                              className={
                                                                "form-select"
                                                              }
                                                              allData={data}
                                                              formik={formik}
                                                              completedPage={ress.completedPage}
                                                            />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type === "multiSelect" ? (
                                                            <>
                                                              <FormikControl
                                                                control="multiSelect"
                                                                type={data?.type}
                                                                name={data.name}
                                                                className={"form-select"}
                                                                allData={data}
                                                                formik={formik}
                                                                completedPage={ress.completedPage}
                                                              />
                                                            </>
                                                          ) : (
                                                            ""
                                                        )}
                                                        {data.type === "date" ? (
                                                          <>
                                                            <FormikControl
                                                              control="date"
                                                              type={data.type}
                                                              name={data.name}
                                                              className={
                                                                "form-control"
                                                              }
                                                              allData={data}
                                                              dateFormat={
                                                                data.dateFormat
                                                              }
                                                              completedPage={ress.completedPage}
                                                            />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type === "text" ||
                                                          data.type === "number" || data.type === "split-input" ? (
                                                          <>
                                                            <FormikControl
                                                              control={data.type === "split-input" ? data.type : "input"}
                                                              type={data.type}
                                                              name={data.name}
                                                              className={
                                                                "form-control"
                                                              }
                                                              formik={formik}
                                                              onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => data?.isSignature === true ? candidateSignatures(data?.name) : ""}
                                                              completedPage={ress.completedPage}
                                                              // allData={data}
                                                              allData={
                                                                checkValidationElement.filter(
                                                                  (item: any) =>
                                                                    item.child_name ===
                                                                    data.name
                                                                )[0]
                                                                  ?.childValidation
                                                                  ? {
                                                                    ...data,
                                                                    validate:
                                                                      true,
                                                                  }
                                                                  : data
                                                              }
                                                              clearChilInput={clearChilInput}
                                                              doTfnFormValidation={doTfnFormValidation}
                                                            />
                                                            {
                                                              data.isSignature === true && (
                                                                <div className={"model-sign " + data?.name}>
                                                                  {candidateSignModel[data?.name] || ""}
                                                                </div>
                                                              )
                                                            }
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type ===
                                                          "textarea" ? (
                                                          <>
                                                            <FormikControl
                                                              control="textarea"
                                                              type={data.type}
                                                              name={data.name}
                                                              className={
                                                                "form-control"
                                                              }
                                                              allData={data}
                                                            />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type ===
                                                          "radio-group" ? (
                                                          <>
                                                            <FormikControl
                                                              control="radio"
                                                              name={data.name}
                                                              className={
                                                                "form-control"
                                                              }
                                                              option={data.values}
                                                              allData={data}
                                                              formik={formik}
                                                              onClick={clearValueForChildElement()}
                                                              setDoTfnFormValidation={setDoTfnFormValidation}
                                                            />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type ===
                                                          "checkbox-group" ||
                                                          data.type ===
                                                          "checkbox" ? (
                                                          <>
                                                            <FormikControl
                                                              control="checkbox"
                                                              name={data.name}
                                                              className={
                                                                "form-control"
                                                              }
                                                              option={data.values}
                                                              allData={data}
                                                              candidateData={candidateData}
                                                              initialCandidateName={`${candidateData?.candidateDetails?.firstName} ${candidateData?.candidateDetails?.lastName}`} />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type === "file" ? (
                                                          <>
                                                            <>
                                                              {inputTypeFile(
                                                                formik,
                                                                data,
                                                                i
                                                              )}
                                                            </>
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </div>
                                                    </div>
                                                    {data.type === "hr" ? (
                                                      <hr />
                                                    ) : (
                                                      ""
                                                    )}
                                                    {data.status &&
                                                      data.name === "subForm-1" ? (
                                                      <>
                                                        {subForm_1(
                                                          formik,
                                                          ress.fields,
                                                        )}
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                    {data.status &&
                                                      data.name === "subForm-2" ? (
                                                      <>
                                                        {subForm_2(
                                                          formik,
                                                          ress.fields
                                                        )}
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}

                                                    {data.status &&
                                                      data.name === "subForm-3" ? (
                                                      <>
                                                        {subForm_3(
                                                          formik,
                                                          ress.fields,
                                                        )}
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </div>
                                                </div>
                                              ) : (
                                                <>{errorControl(data, formik)}</>
                                              )}
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      );
                                    })}
                                  <div></div>
                                </div>
                                {
                                  formik?.errors && <ErrorSummary errors={formik.errors} />
                                }


                                {signingUrl?.length > 0 && isTfnForm === 1 ? (
                                  <div className="signed_url_wrapper">
                                    <Iframe url={signingUrl} />
                                  </div>
                                ) : null}

                                {/* <FormikControl
                                  control="input"
                                  allData={{ placeholder: "Enter your name" }}
                                  name="signature"
                                  className={"form-control"}
                                  onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => candidateSignatures("signature")}
                                  /> */}



                                {superSigningUrl?.length > 0 && isSuperForm === 1 ? (
                                  <div className="signed_url_wrapper">
                                    <Iframe url={superSigningUrl} />
                                  </div>
                                ) : null}



                                {/* Submit/Next step buttons */}
                                {screenShort.active ? (
                                  <div className="btn-section">
                                    {/* onClick={() => { formstatus = ""; fileUploadData(); }} */}

                                    {(isTfnForm === 1 && signingUrl.length > 0) ? (
                                      <Button
                                        onClick={showEditTFNForm}
                                        type="button"
                                        icon="pi pi-arrow-left"
                                        position="right"
                                        label={"Edit TFN Form"}
                                        clasName="btn btn-primary check_tfn_form_btn"
                                      />
                                    ) : ""}

                                    {(isSuperForm === 1 && superSigningUrl?.length > 0) ? (
                                      <Button
                                        onClick={showEditSuperForm}
                                        type="button"
                                        icon="pi pi-arrow-left"
                                        position="right"
                                        label={"Edit Super Form"}
                                        clasName="btn btn-primary check_tfn_form_btn"
                                      />
                                    ) : ""}


                                    <Button
                                      onClick={() => {
                                        updateValudatesetFormstatus("");
                                        const prsForm: any = updateFormData.filter((ress: any) => ress.active);
                                        document.getElementById(`submitBtn_${prsForm[0]["index"]}`)?.click();
                                      }}
                                      type="button"
                                      icon="pi pi-arrow-right"
                                      position="right"
                                      label={(signingUrl.length === 0 || superSignedUrl?.length === 0) ?
                                        ((tfnFormIndex === ress.index || superFormIndex === ress.index) && formik?.dirty) ? "Continue To Signature Step" :
                                          (candidateData?.continueButtonText ? "Continue To Next Step" : (isTFNFormChanges || isSuperFormChanges) ? "Continue To Signature Step" : "Continue To Next Step")
                                        : ((signingUrl.length > 0 || superSignedUrl?.length > 0) && (tfnFormIndex === ress.index || superFormIndex === ress.index)) ? "Continue To Next Step" : "Continue To Signature Step"}

                                      clasName="btn btn-primary"
                                    />
                                    <Button
                                      // onClick={() => updateValudatesetFormstatus("")}
                                      id={`submitBtn_${ress.index}`}
                                      type="submit"
                                      icon="pi pi-arrow-right"
                                      position="right"
                                      label=""
                                      clasName=" d-none btn btn-primary"
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </Form>
                            )
                          )}
                        </Formik>
                        <br />
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div >
      <Model
        show={saveModel}
        modelHeader={modelHeader()}
        modelBody={modelBody()}
        modelClose={() => closeModel()}
      />
      <Model
        size="lg"
        show={countControl.saveModel}
        modelBody={saveModelBody()}
      />
      <Model size="lg" show={saveAndExitModel} modelBody={confirmMass()} />

      {/* <iframe id="pdfPreview" width="100%" height="400"></iframe> */}
    </>
  );
};

export default OnBoarding;
